// console.log("in 3d-model js");
import * as THREE from "three";
import { OrbitControls } from "https://unpkg.com/three@0.148.0/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "https://unpkg.com/three@0.148.0/examples/jsm/loaders/GLTFLoader.js";
import { EffectComposer } from "https://unpkg.com/three@0.148.0/examples/jsm/postprocessing/EffectComposer.js";
import { RenderPass } from "https://unpkg.com/three@0.148.0/examples/jsm/postprocessing/RenderPass.js";

let loadedModels = {};
let scene, renderer, camera, controls;
const apikey = "QaLQzsUNDDcXVPZei0p3fegHMD7AzhJpFoct"; // Replace with your API key
let Lapel_style,
  Lining,
  Shoulders,
  Chest_Pocket,
  Side_pocket,
  Ticket_pockets,
  Vent,
  buttons,
  model,
  dirLight,
  loadingText,
  container;
let aLight = [];
let sCurruntFabric = null;
let curruntFabric = null;
let intialmodel = "taxido-button-1";
let composer, renderPass;
fetchFabrics();
container = document.getElementById("CanvasFrame");
const width = container.clientWidth;
const height = container.clientHeight;

const bodyElement = document.querySelector("body");
const dataPageValue = bodyElement.getAttribute("data-page");

const DEFAULT_FABRIC_TEXTURE_URL ="https://grand-le-mar-media-2.s3.ap-south-1.amazonaws.com/default/Poly_Wool_Fabric_Base_Map1-2.jpg";

const DEFAULT_FABRIC_FALLBACK = {
    repeatable_color_image_url: null,
    repeatable_normal_image_url: null,
    color_r: 128,
    color_g: 128,
    color_b: 128,
    tiling_info: { color_tiling_x: 60, color_tiling_y: 60 },
};

let jacketdiv;
let trouserdiv;
let waistecoatdiv;
let defaultfabriccode = "";

if (dataPageValue == "custom-made-tuxedo-suit") {
  jacketdiv = document.querySelectorAll(
    '.cm-progress-container[data-progress="jacket-design"]'
  )[0];
  trouserdiv = document.querySelectorAll(
    '.cm-progress-container[data-progress="trouser-design"]'
  )[0];
  waistecoatdiv = document.querySelectorAll(
    '.cm-progress-container[data-progress="waistcoat-design"]'
  )[0];
} else {
  jacketdiv = document.getElementsByClassName("cm-preview-block")[0];
  trouserdiv = document.getElementsByClassName("cm-preview-block")[0];
  waistecoatdiv = document.getElementsByClassName("cm-preview-block")[0];
}

// For Taxido Jacket
let Buttoning_value = "taxido-button-1";
let Lapel_style_value = "peak";
let sTuxedoColor = "black";
let sColorType = "satin"
let Lapel_width = "wide";
let Lapel_buttonhole = "Traditional";
let AMF_Size = "mm2";
let hole_Position = "right";
let Shoulder = "Natural_Shoulder_0mm";
let Chest_Pocket_value = "Boat_Shape";
let side_pocket_value = "Jetted001";
let Ticket_pocket_value = false;
let Vent_value = "double";
let Sleeve_Button_value = "kissing_3";
let Lining_value = "full";
let oCurruntFabric = null;
let Cuffed_sleeve_value = false;
// let sButtons_texture = "FABRIC-COVERED-BUTTONS";
let sButtons_texture = "1 (Black with small stain)";

// For Taxido Trouser

let waistband,
  back_Pockets,
  side_Pockets,
  coin_Pocket,
  pleats,
  hemFinishing,
  fasteting;
let coin_pocket_value = true;
let Hem_finishing_value = "None";
let Pleat = "Normal_straight_pant";
let pocket_side = "Slanted";
let TAMF_Size = "AMF_2";
let pockets_back = "jetted_Button";
let waistband_value = "Oscar_Straight";
let waistband_height = 0;
let fasteting_value = "None";
let colorTuxedo = "#000000";
let sLiningColor = "#FFFFFF";

// For Taxido Waistcoat

let WCollar_Styles;
let Wback_Pockets;
let WChest_Pocket;
let WSide_pocket;
let twpocketSide = "Straight_pocket";
let twpocketsBack = "Single_pocket";
let isHorseStyle = true;
let twcollarStyle = "Horse";
let amfSize = "AMF_2";
let twbuttoning = "Double_Breasted_6_button_V";
let twbackStyle = "Lining";
// let twcolorFabric = document.getElementById("color-fabric");
let backFabrics = false;
let backColor = "#ffffff";

let jacketactive = false;
let trouseractive = false;
let waistcoatactive = false;

let allfabrics;

const init = () => {
  scene = new THREE.Scene();
  // scene.background = new THREE.Color(0x000b1b2f);
  camera = new THREE.OrthographicCamera(
    width / -470,
    width / 470,
    height / 470,
    height / -470,
    1,
    1000
  );
  camera.position.z = 60;
  camera.updateProjectionMatrix();
  camera.lookAt(0, 0, 0);
  renderer = new THREE.WebGLRenderer({
    alpha: true,
    antialias: true,
    preserveDrawingBuffer: true,
    powerPreference: "high-performance",
  });
  renderer.toneMapping = THREE.CineonToneMapping;
  renderer.shadowMap.enabled = true;
  renderer.gammaInput = true;
  renderer.gammaOutput = true;
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(width, height);

  composer = new EffectComposer(renderer);

  renderPass = new RenderPass(scene, camera);
  composer.addPass(renderPass);

  container.appendChild(renderer.domElement);
  // addLights();

  if (
    dataPageValue == "custom-made-tuxedo-trouser" ||
    trouserdiv.classList.contains("isSelected")
  ) {
    loadGLTFmoadl("Tuxedo_Trousers");
    trouseractive = true;
    jacketactive = false;
    waistcoatactive = false;
  } else if (
    dataPageValue == "custom-made-tuxedo-waistcoat" ||
    waistecoatdiv.classList.contains("isSelected")
  ) {
    loadGLTFmoadl("Tuxedo_waistcoat");
    waistcoatactive = true;
    jacketactive = false;
    trouseractive = false;
  } else {
    loadGLTFmoadl(intialmodel);
    jacketactive = true;
    waistcoatactive = false;
    trouseractive = false;
  }

  const addDirectionalLight = (x, y, z, intensity) => {
    // dirLight = new THREE.DirectionalLight(0xd5deff, intensity);
    dirLight = new THREE.DirectionalLight(0xffffff, intensity);
    aLight.push(dirLight);
    dirLight.castShadow = true;
    aLight.target = model;
    camera.add(dirLight);
    scene.add(dirLight);
  };
  addDirectionalLight(0, 0, 0, 4);
  //  if (dataPageValue == 'custom-made-tuxedo-trouser') {
  //     loadGLTFmoadl('Tuxedo_Trousers');
  // }
  // else if (dataPageValue == 'custom-made-tuxedo-waistcoat') {
  //     loadGLTFmoadl('Tuxedo_waistcoat');
  // }
  // else if (dataPageValue == 'custom-made-tuxedo-jacket' ) {
  //   loadGLTFmoadl(intialmodel);
  // }

  animate();
  orbitControls();
  //loadLodingText();
};

const animate = () => {
  if (controls) controls.update();
  if (dirLight) {
    dirLight.position.set(
      camera.position.x + 5,
      camera.position.y + 7,
      camera.position.z + 20
    );
  }
  requestAnimationFrame(animate);
  composer.render();
};
window.addEventListener("resize", () => {
  camera.left = width / -470;
  camera.right = width / 470;
  camera.top = height / 470;
  camera.bottom = height / -470;
  camera.updateProjectionMatrix();
  renderer.setSize(width, height);
});

async function loadGLTFmoadl(glbModel) {
  if (model) {
    scene.remove(model);
  }
  const loader = new GLTFLoader();
  const staticURL1 = "https://grand-le-mar-media-2.s3.ap-south-1.amazonaws.com/";
  const fullURL = `${staticURL1}${glbModel}.glb`;
  // await loader.loadAsync(`test.glb`).then((glb) => {
  await loader.loadAsync(fullURL).then(async (glb) => {
    model = glb.scene;
    console.log("model full", model)
    model.visible = false;
    if (
      dataPageValue == "custom-made-tuxedo-trouser" ||
      trouserdiv.classList.contains("isSelected")
    ) {
      model.scale.set(0.222, 0.222, 0.222);
      model.position.y += 0.08;
    } else if (
      dataPageValue == "custom-made-tuxedo-waistcoat" ||
      waistecoatdiv.classList.contains("isSelected")
    ) {
      model.scale.set(0.44, 0.44, 0.44);
      model.position.y -= 0.15;
    } else {
      model.scale.set(0.0125, 0.0125, 0.0125);
    }
    scene.add(model);
    model.children.forEach((child) => {
      child.castShadow = true;
      child.receiveShadow = true;
    });
    if (
      dataPageValue == "custom-made-tuxedo-trouser" ||
      trouserdiv.classList.contains("isSelected")
    ) {
      waistband = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "Waistband".substring(0, 4)
      )[0];
      coin_Pocket = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "Coin_pocket".substring(0, 4)
      )[0];
      fasteting = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "Fasteting".substring(0, 4)
      )[0];
      pleats = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "PLeats".substring(0, 4)
      )[0];
      hemFinishing = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "HemFinishing".substring(0, 4)
      )[0];
      side_Pockets = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "Sidepockets".substring(0, 4)
      )[0];
      back_Pockets = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "Backpocket".substring(0, 4)
      )[0];

      pleats.children[0].children[1].material.color.set("#000000");
      // pleats.children[0].children[1].material.emissive.set('#0a0a0a');
      pleats.children[0].children[1].material.color.roughness = 1;

      update_Hem_finishing();
      update_Pleats();
      update_side_Pockets();
      update_Back_Pockets();
      update_Waistband();
      TupdateTuxedoColor();
      if (loadingText) {
        loadingText.remove();
      }
      if (document.body.classList.contains("line-loading-3d-preview")) {
        document.body.classList.remove("line-loading-3d-preview");
      }
      TupdateMaterialFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
      updateButtonImage(coin_Pocket.children[0].children[0].material);
    } else if (
      dataPageValue == "custom-made-tuxedo-waistcoat" ||
      waistecoatdiv.classList.contains("isSelected")
    ) {
      WCollar_Styles = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "buttonning".substring(0, 4)
      )[0];
      Wback_Pockets = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "back".substring(0, 4)
      )[0];
      WChest_Pocket = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "Chest_pocket".substring(0, 4)
      )[0];
      WSide_pocket = model.children[0].children.filter(
        (child) => child.name.substring(0, 4) === "Side_pocket".substring(0, 4)
      )[0];
      updateButtonImage(WCollar_Styles.children[0].children[3].material);

      updateSidePockets();
      updateChestPockets();
      updateCollarStyles();
      updateBackColor("#FFFFFF");
      if (loadingText) {
        loadingText.remove();
      }
      if (document.body.classList.contains("line-loading-3d-preview")) {
        document.body.classList.remove("line-loading-3d-preview");
      }
      WupdateMaterialFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
    } else {
      Lapel_style = model.children.filter(
        (child) =>
          child.name.substring(0, 4).toUpperCase() ===
          "Lapel_style".substring(0, 4).toUpperCase()
      )[0];
      Lining = model.children.filter(
        (child) => child.name.substring(0, 4) === "Lining".substring(0, 4)
      )[0];
      Shoulders = model.children.filter(
        (child) => child.name.substring(0, 4) === "Shoulders".substring(0, 4)
      )[0];
      Chest_Pocket = model.children.filter(
        (child) => child.name.substring(0, 4) === "Chest_Pocket".substring(0, 4)
      )[0];
      Side_pocket = model.children.filter(
        (child) => child.name.substring(0, 4) === "Side_pocket".substring(0, 4)
      )[0];
      Ticket_pockets = model.children.filter(
        (child) =>
          child.name.substring(0, 4) === "Ticket_pockets".substring(0, 4)
      )[0];
      buttons = model.children.filter(
        (child) => child.name.substring(0, 4) === "buttons".substring(0, 4)
      )[0];

      // document.getElementById("Buttoning").value === "button-6" && (buttons = model.children.filter((child) => child.name === "Button")[0])

      update_Lapel_width();
      update_Shoulders();
      update_Side_Pocket();
      update_Ticket_pockets();
      update_Vent();
      update_Lining();

      update_Chest_Pocket();

      console.log("updateTuxedoColor",Lapel_style?.children?.[0]?.children?.[2],Ticket_pockets)
      updateTuxedoColor();
      // update_Cuffed_sleeve()
      update_Sleeve_Button();
      if (loadingText) {
        loadingText.remove();
      }
      if (document.body.classList.contains("line-loading-3d-preview")) {
        document.body.classList.remove("line-loading-3d-preview");
      }
      update_lining_color();
      await updateMaterialFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
      updateButtonImage(buttons.children[3].children[1].material);

      // setTimeout(()=>{
      update_Cuffed_sleeve();
      // },100)
    }
  });
  if (document.body.classList.contains("line-loading-3d-preview")) {
    document.body.classList.remove("line-loading-3d-preview");
  }
}
const orbitControls = () => {
  controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.enablePan = false;
  controls.minPolarAngle = Math.PI / 2;
  controls.maxPolarAngle = Math.PI / 2;
  controls.minZoom = 0.75;
  controls.enableZoom = false;

  controls.maxZoom = 1.5;
};

function loadLodingText() {
  loadingText = document.createElement("div");
  loadingText.innerHTML = "Loading...";

  container.appendChild(loadingText);
  const logo = document.createElement("img");
  logo.src = "https://grandlemar.com/cdn/shop/t/152/assets/logo.svg";
  loadingText.appendChild(logo);
  loadingText.classList.add("loading-text");
}
function loadLoader() {
  $("body").hasClass("line-loading-3d-preview")
    ? ""
    : $("body").addClass("line-loading-3d-preview");
}
function removeLoader() {
  $("body").hasClass("line-loading-3d-preview")
    ? $("body").removeClass("line-loading-3d-preview")
    : "";
}
const addLights = () => {
  dirLight = new THREE.SpotLight(0xd5deff);
  dirLight.distance = 0;
  dirLight.intensity = 5;
  dirLight.penumbra = 1;
  dirLight.decay = 2;
  dirLight.castShadow = true;
  dirLight.shadow.mapSize.width = 1024;
  dirLight.shadow.mapSize.height = 1024;
  dirLight.shadow.camera.near = 0.5;
  dirLight.shadow.camera.far = 500;
  dirLight.shadow.focus = 1;
  dirLight.shadow.bias = -0.0001;
  dirLight.shadow.normalBias = 0.05;
  dirLight.shadow.radius = 1;
  aLight.push(dirLight);

  scene.add(dirLight);
};
init();

// For Taxido Jacket
function ButtoningValue() {
  if (
    Buttoning_value.value === "button-6" ||
    Buttoning_value.value === "button-7"
  ) {
    Lapel_style.value = "peak";
    Lapel_style.disabled = true;
  } else {
    Lapel_style.disabled = false;
  }

  if (Lapel_style.value === "Shawl") {
    Buttoning_value.children[3].style.display = "none";
    Buttoning_value.children[4].style.display = "none";
  } else {
    Buttoning_value.children[3].style.display = "block";
    Buttoning_value.children[4].style.display = "block";
  }
}

// function updateMaterial(material, color) {
// //   console.log("updateMaterial", color)
//     if (color === 'None') {
//        material.metalnessMap = null;
//          updateMaterialTextures(material, oCurruntFabric);
//         // material.color.set(0xffffff);
//         material.needsUpdate = true;
//     } else {
//         material.roughness = 1;
//         const textureLoader = new THREE.TextureLoader();

//         const loadTexture = (url, callback) => {
//             textureLoader.load(url, (texture) => {
//                 callback(texture);
//             });
//         };

//         loadTexture(`https://d3khmbboykqtpb.cloudfront.net/lapelMaterial/${color}/laper_Base_color.png`, (texture) => {
//             material.map = texture;
//             material.encoding = THREE.sRGBEncoding;
//             material.wrapS = material.wrapT = THREE.RepeatWrapping;
//             texture.repeat.set(25, 25);
//         });
//         loadTexture(`https://d3khmbboykqtpb.cloudfront.net/lapelMaterial/${color}/laper_Normal.png`, (texture) => {
//             material.normal = texture;
//         });
//         loadTexture(`https://d3khmbboykqtpb.cloudfront.net/lapelMaterial/${color}/laper_Roughness.png`, (texture) => {
//             material.roughnessMap = texture;
//         });
//         loadTexture(`https://d3khmbboykqtpb.cloudfront.net/lapelMaterial/${color}/laper_Metallic.png`, (texture) => {
//             material.metalnessMap = texture;
//         });
//         material.metalness = 1;
//         material.roughness = 0.75;
//         material.needsUpdate = true;
// }
// }

function resetMaterial(material) {
  if(!material) return
  material.color.set(0xffffff);   // CRITICAL
  material.metalness = 0;
  material.roughness = 1;

  material.map = null;
  material.normalMap = null;
  material.roughnessMap = null;
  material.metalnessMap = null;
}

async function updateMaterial (material, color, type) {
  resetMaterial(material);
  if (color === "None") {
    material.metalnessMap = null;
    material.map = null;
    material.normalMap = null;
    material.roughnessMap = null;
    material.color.multiplyScalar(1.0);
    await updateMaterialTextures(material, oCurruntFabric);
    material.needsUpdate = true;
  } else {
    material.roughness = 1;
    const textureLoader = new THREE.TextureLoader();
    const loadTexture = async (url, callback) => {
      try {
        const texture = await textureLoader.loadAsync(url);
        callback(texture);
        return texture;
      } catch (error) {
        console.error(`Failed to load texture: ${ url }`, error);
        return null;
      }
    };


    const [colorTexture, normalTexture, roughnessTexture, metalnessTexture] =
      await Promise.all([
        loadTexture(
          `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/lapelMaterial/${ type }/${ color }/laper_Base_color.png`,
          (texture) => texture
        ),
        loadTexture(
          `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/lapelMaterial/${ type }/${ color }/laper_Normal.png`,
          (texture) => texture
        ),
        loadTexture(
          `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/lapelMaterial/${ type }/${ color }/laper_Roughness.png`,
          (texture) => texture
        ),
        loadTexture(
          `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/lapelMaterial/${ type }/${ color }/laper_Metallic.png`,
          (texture) => texture
        ),
      ]);

    material.metalnessMap = null;
    material.map = null;
    material.normalMap = null;
    material.roughnessMap = null;
    
    if (colorTexture) {
      colorTexture.repeat.set(25, 25);
      colorTexture.encoding = THREE.sRGBEncoding;
      colorTexture.wrapS = colorTexture.wrapT = THREE.RepeatWrapping;
      material.map = colorTexture;
    } else {
      material.map = null;
    }
    
    material.normalMap = normalTexture || null;
    material.roughnessMap = roughnessTexture || null;
    material.metalnessMap = metalnessTexture || null;

    if (type === "grosgrain") {
      material.roughness = 0.8;
      material.metalness = 0.7;
      material.map.repeat.set(6, 6); // Decrease repetition
      material.color.multiplyScalar(0.8);
    } else {
      material.metalness = 1;
      material.roughness = 0.75;
    }

    material.map.wrapS = THREE.RepeatWrapping;
    material.map.wrapT = THREE.RepeatWrapping;
    material.map.needsUpdate = true;
  }
}

function updateTuxedoColor() {

  const lapelMaterial =
  Lapel_style?.children?.[0]?.children?.[2]?.children?.[0].material;

const ticketPocketMaterial =
  Ticket_pockets?.children?.[0]?.children?.[1]?.material;

  updateMaterial(lapelMaterial, sTuxedoColor, sColorType );
  updateMaterial(ticketPocketMaterial, sTuxedoColor, sColorType);
}

const updateButtonImage = async (buttonMaterial) => {
  const textureLoader = new THREE.TextureLoader();
  sButtons_texture =
    sButtons_texture === "1-(Black-with-small-stain)"
      ? "1 (Black with small stain)"
      : sButtons_texture;

  let url = `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/buttons/Tuxedo/${sButtons_texture}.png`;
  if (sButtons_texture === "FABRIC-COVERED-BUTTONS") {
    url = sCurruntFabric.repeatable_color_image_url;
  }
  textureLoader.load(url, function (texture) {
    // Dispose of the old texture to avoid memory leaks
    if (buttonMaterial.map) {
      buttonMaterial.map.dispose();
    }
    // Adjust texture settings
    texture.encoding = THREE.sRGBEncoding;
    texture.needsUpdate = true;

    buttonMaterial.map = texture;
    buttonMaterial.needsUpdate = true;
    buttonMaterial.metalness = 1;
    buttonMaterial.roughness = 1;
  });
};

// const updateMaterialFabric = (fabric) => {
//     oCurruntFabric = fabric;
//     updateTuxedoColor();
//     updateMaterialTextures(Side_pocket.children[4].material, fabric);
//     updateMaterialTextures(Shoulders.children[5].material, fabric);
//     updateMaterialTextures(Shoulders.children[0].material, fabric);

//     getColorIntensityCategory(fabric.color_r, fabric.color_g, fabric.color_b);

//     // Lapel_style.children[0].children[2].children[3].material.emissive.setRGB(fabric.color_r / 255, fabric.color_g / 255, fabric.color_b / 255);
//     Lapel_style.children[0].children[3].children[0].material.needsUpdate = true;

// };
// function updateMaterialTextures(material, fabric) {
//     const textureLoader = new THREE.TextureLoader();
//     const loadTexture = (url, callback) => {
//         textureLoader.load(url, (texture) => {
//             callback(texture);
//             material.needsUpdate = true;
//         });
//     };
// //     console.log(fabric)

//     // if (fabric.metalness_hq_image_url || fabric.repeatable_metalness_image_url) {
//     //     loadTexture(fabric.metalness_hq_image_url || fabric.repeatable_metalness_image_url, (texture) => {
//     //         material.metalnessMap = texture;
//     //     });
//     // }
//     // if (fabric.repeatable_roughness_hq_image_url || fabric.repeatable_roughness_image_url) {
//     //     loadTexture(fabric.repeatable_roughness_hq_image_url || fabric.repeatable_roughness_image_url, (texture) => {
//     //         material.roughnessMap = texture;
//     //     });
//     // }
//     // if (fabric.repeatable_displacement_hq_image_url || fabric.repeatable_displacement_image_url) {
//     //     loadTexture(fabric.repeatable_displacement_hq_image_url || fabric.repeatable_displacement_image_url, (texture) => {
//     //         material.displacement = texture;
//     //     });
//     // }
//     if ( fabric.repeatable_normal_image_url) {
//         loadTexture( fabric.repeatable_normal_image_url, (texture) => {
//             material.normal = texture;
//         });
//     }
//     // if (fabric.repeatable_rma_hq_image_url || fabric.repeatable_rma_image_url) {
//     //     loadTexture(fabric.repeatable_rma_hq_image_url || fabric.repeatable_rma_image_url, (texture) => {
//     //         material.rma = texture;
//     //     });
//     // }
//     // if (fabric.repeatable_specular_hq_image_url || fabric.repeatable_specular_image_url) {
//     //     loadTexture(fabric.repeatable_specular_hq_image_url || fabric.repeatable_specular_image_url, (texture) => {
//     //         material.specular = texture;
//     //     });
//     // }
//     // if (fabric.repeatable_ao_hq_image_url || fabric.repeatable_ao_image_url) {
//     //     loadTexture(fabric.repeatable_ao_hq_image_url || fabric.repeatable_ao_image_url, (texture) => {
//     //         material.ao = texture;
//     //     });
//     // }

//     // Load and set color map (diffuse map)
//     if ( fabric.repeatable_color_image_url) {
//         loadTexture( fabric.repeatable_color_image_url, (texture) => {
//             texture.encoding = THREE.sRGBEncoding;
//             texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
//             const nTiling_percentages = 1;
//             texture.repeat.set((fabric.tiling_info.color_tiling_x) * nTiling_percentages, (fabric.tiling_info.color_tiling_y) * nTiling_percentages);
//             material.map = texture;
//             texture.minificationFilter = THREE.LinearFilter;
//             texture.magFilter = THREE.LinearFilter;
//             texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
//             material.needsUpdate = true;
//         });
//     }
//     material.userData.colorInfo = fabric.color_info

//     // Update other material properties
//     // material.depthWrite = true;
//     // material.displacementScale = fabric.displacement_scale || 0;
//     material.metalness = 0;
//     material.roughness = 1;
//     // material.specular_value = fabric.specular_value || 0;
//     // material.shininess = 50;

//     material.needsUpdate = true;
// }

const loadTextureWithFallback = async (textureLoader, primaryUrl, fallbackUrl) => {
    if (primaryUrl) {
        try {
            return await textureLoader.loadAsync(primaryUrl);
        } catch (error) {
            console.error("Error loading texture:", error);
        }
    }
    if (fallbackUrl) {
        try {
            return await textureLoader.loadAsync(fallbackUrl);
        } catch (error) {
            console.error("Error loading fallback texture:", error);
        }
    }
    return null;
};

const getFabricTiling = (fabric, multiplier = 1) => {
    const tilingX = (fabric?.tiling_info?.color_tiling_x ?? 1) * multiplier;
    const tilingY = (fabric?.tiling_info?.color_tiling_y ?? 1) * multiplier;
    return { tilingX, tilingY };
};

const RGBtoHex = (r, g, b) => {
    const colorToHex = (color) => {
        const hexadecimal = color.toString(16);
        return hexadecimal.length == 1 ? "0" + hexadecimal : hexadecimal;
    };
    return "#" + colorToHex(r) + colorToHex(g) + colorToHex(b);
};


const updateMaterialFabric = async (fabric) => {
    oCurruntFabric = fabric;
    updateTuxedoColor();
    const fabricMaterialTasks = [
        updateMaterialTextures(Side_pocket.children[4].material, fabric),
        updateMaterialTextures(Shoulders.children[5].material, fabric),
        updateMaterialTextures(Shoulders.children[0].material, fabric),
    ];
    if (fabric !== DEFAULT_FABRIC_FALLBACK) {
        fabricMaterialTasks.unshift(
            updateMaterialTextures(
                Lapel_style.children[0].children[1].material,
                fabric
            )
        );
    }
    await Promise.all(fabricMaterialTasks);
    getColorIntensityCategory(fabric.color_r, fabric.color_g, fabric.color_b);
    Lapel_style.children[0].children[3].children[0].material.needsUpdate = true;
};

async function updateMaterialTextures(material, fabric) {
    const textureLoader = new THREE.TextureLoader();
    const [normalTexture, colorTexture] = await Promise.all([
        loadTextureWithFallback(
            textureLoader,
            fabric?.repeatable_normal_image_url,
            null
        ),
        loadTextureWithFallback(
            textureLoader,
            fabric?.repeatable_color_image_url,
            DEFAULT_FABRIC_TEXTURE_URL
        ),
    ]);
    if (normalTexture) {
        material.normal = normalTexture;
    }
    if (colorTexture) {
        colorTexture.encoding = THREE.sRGBEncoding;
        colorTexture.wrapS = colorTexture.wrapT = THREE.RepeatWrapping;
        const { tilingX, tilingY } = getFabricTiling(fabric, 6);
        colorTexture.repeat.set(tilingX, tilingY);
        material.map = colorTexture;
    } else {
        material.map = null;
        material.color?.set?.(
            RGBtoHex(fabric.color_r, fabric.color_g, fabric.color_b)
        );
    }
    material.userData.colorInfo = fabric.color_info;
    material.metalness = 0;
    material.roughness = 1;
    material.needsUpdate = true;
    if (model) model.visible = true;
}

const update_lining_color = () => {
  Lining.children[0].material.map = null;
  Lining.children[0].material.metalnessMap = null;
  Lining.children[0].material.roughnessMap = null;
  Lining.children[0].material.normal = null;
  Lining.children[0].material.color.set(sLiningColor);
  Lining.children[0].material.needsUpdate = true;

  // const textureLoader = new THREE.TextureLoader();
  // const url = `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/buttons/jacket/gray-lines.jpg`;
  
  // textureLoader.load(url, function (texture) {
  //   // Dispose of the old texture to avoid memory leaks
  //   if (Lining.children[0].material.map) {
  //     Lining.children[0].material.map.dispose();
  //   }
  //   // Adjust texture settings
  //   texture.encoding = THREE.sRGBEncoding;
  //   texture.needsUpdate = true;

  //   Lining.children[0].material.map = texture;
  //   Lining.children[0].material.needsUpdate = true;
  //   Lining.children[0].material.metalness = 1;
  //   Lining.children[0].material.roughness = 1;
  //   });
};

const TupdateMaterialTextures = (material, fabric) => {
    const textureLoader = new THREE.TextureLoader();
    const loadTexture = (url, callback) => {
        textureLoader.load(url, (texture) => {
            callback(texture);
            material.needsUpdate = true;
        });
    };

    if (fabric.repeatable_metalness_image_url) {
        loadTexture(fabric.repeatable_metalness_image_url, (texture) => {
            material.metalnessMap = texture;
        });
    }

    // Load and set roughness map
    if (fabric.repeatable_roughness_image_url) {
        loadTexture(fabric.repeatable_roughness_image_url, (texture) => {
            material.roughnessMap = texture;
        });
    }
    if (fabric.repeatable_displacement_image_url) {
        loadTexture(fabric.repeatable_displacement_image_url, (texture) => {
            material.displacement = texture;
        });
    }
    if (fabric.repeatable_normal_image_url) {
        loadTexture(fabric.repeatable_normal_image_url, (texture) => {
            material.normal = texture;
        });
    }
    if (fabric.repeatable_rma_image_url) {
        loadTexture(fabric.repeatable_rma_image_url, (texture) => {
            material.rma = texture;
        });
    }
    if (fabric.repeatable_specular_image_url) {
        loadTexture(fabric.repeatable_specular_image_url, (texture) => {
            material.specular = texture;
        });
    }
    if (fabric.repeatable_ao_image_url) {
        loadTexture(fabric.repeatable_ao_image_url, (texture) => {
            material.ao = texture;
        });
    }

    const trouserColorUrl =
        fabric.repeatable_color_image_url || DEFAULT_FABRIC_TEXTURE_URL;
    if (trouserColorUrl) {
        loadTexture(trouserColorUrl, (texture) => {
            texture.encoding = THREE.sRGBEncoding;
            texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
            const tilingX =
                ((fabric.tiling_info && fabric.tiling_info.color_tiling_x) ||
                    1) * 0.5;
            const tilingY =
                ((fabric.tiling_info && fabric.tiling_info.color_tiling_y) ||
                    1) * 0.5;
            texture.repeat.set(tilingX, tilingY);
            material.map = texture;
        });
    }

    material.displacementScale = fabric.displacement_scale || 0;
    material.metalness = fabric.metalness || 0;
    material.roughness = fabric.roughness || 1;
    material.specular_value = fabric.specular_value || 0;
    material.shininess = fabric.shininess;
    material.needsUpdate = true;
    model.visible = true;
};


function getColorIntensityCategory(color_r, color_g, color_b) {
  // Convert RGB to linear light (gamma correction)
  const toLinear = (c) =>
    c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;

  // Normalize RGB values
  const rLinear = toLinear(color_r / 255);
  const gLinear = toLinear(color_g / 255);
  const bLinear = toLinear(color_b / 255);

  // Calculate luminance
  const luminance = 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;

  // Determine the intensity category
  let intensity = getIntensity(luminance);
  // log
  if (dataPageValue == "custom-made-tuxedo-jacket") {
    Lapel_style.children[0].children[2].children[0].material.refiectivity = 0;
  }

  if (luminance <= 0.045) {
    // Lapel_style.children[0].children[2].children[0].material.roughness = luminance;
  } else {
    // Lapel_style.children[0].children[2].children[0].material.roughness = 0.4;
    // Lapel_style.children[0].children[2].children[0].material.refiectivity = 0;
  }
  // // console.log(luminance, intensity, color_r, color_g, color_b);

  // // Apply intensity to all lights
  // aLight.forEach((light) => {
  //     light.intensity = intensity;
  // });
}
function getIntensity(luminance) {
  switch (true) {
    case luminance < 0.001:
      return 20;
    case luminance < 0.005:
      return 13;
    case luminance < 0.01:
      return 11;
    case luminance < 0.05:
      return 5;
    case luminance < 0.1:
      return 5;
    case luminance < 0.25:
      return 2.5;
    case luminance < 0.3:
      return 2;
    case luminance < 0.4:
      return 2;
    case luminance < 0.5:
      return 1.5;
    case luminance < 0.6:
      return 1.5;
    case luminance < 0.7:
      return 1;
    case luminance <= 0.81:
      return 1;
    case luminance < 0.9:
      return 0.5;
    default:
      return 0.1;
  }
}
const update_Lapel_width = () => {
  Lapel_style.children.forEach((child) => (child.visible = false));
  Lapel_style.children
  .filter((child) => child.name === Lapel_style_value)[0]
  .children.filter((child) => (child.visible = false));
  Lapel_style.children.filter(
    (child) => child.name === Lapel_style_value
  )[0].visible = true;
  Lapel_style.children
  .filter((child) => child.name === Lapel_style_value)[0]
  .children.filter(
    (child) => child.name.substring(0, 1) === Lapel_width.substring(0, 1)
  )[0].visible = true;
  
  // // Lapel_buttonhole

  Lapel_style.children
    .filter((child) => child.name === Lapel_style_value)[0]
    .children.filter(
      (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
    )[0]
    .children.forEach((child) => (child.visible = false));
  Lapel_style.children
    .filter((child) => child.name === Lapel_style_value)[0]
    .children.filter(
      (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
    )[0].visible = true;

  console.log("debug-2",Lapel_buttonhole)
  console.log("debug-1",Lapel_style.children
    .filter((child) => child.name === Lapel_style_value)[0]
    .children.filter(
      (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
    )[0].children)

  Lapel_style.children
    .filter((child) => child.name === Lapel_style_value)[0]
    .children.filter(
      (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
    )[0]
    .children.filter(
      (child) => child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
    )[0].visible = true;

  Lapel_style.children
    .filter((child) => child.name === Lapel_style_value)[0]
    .children.filter(
      (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
    )[0]
    .children.filter(
      (child) => child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
    )[0]
    .children.forEach((child) => (child.visible = false));

  // Lapel_button_hole_Position

  if (hole_Position === "Both") {
    Lapel_style.children
      .filter((child) => child.name === Lapel_style_value)[0]
      .children.filter(
        (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
      )[0]
      .children.filter(
        (child) =>
          child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
      )[0]
      .children.forEach((child) => (child.visible = true)),
      Lapel_style.children
        .filter((child) => child.name === Lapel_style_value)[0]
        .children.filter(
          (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
        )[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
        )[0]
        .children.forEach((child) =>
          child.children.forEach((child) => (child.visible = false))
        ),
      Lapel_style.children
        .filter((child) => child.name === Lapel_style_value)[0]
        .children.filter(
          (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
        )[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
        )[0]
        .children.forEach((child) =>
          child.children.forEach(
            (child) =>
              child.name.substring(0, 1).toUpperCase() ===
                Lapel_width.substring(0, 1).toUpperCase() &&
              (child.visible = true)
          )
        );
  } else {
    hole_Position !== "None" &&
      ((Lapel_style.children
        .filter((child) => child.name === Lapel_style_value)[0]
        .children.filter(
          (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
        )[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
        )[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 3).toUpperCase() ===
            hole_Position.substring(0, 3).toUpperCase()
        )[0].visible = true),
      Lapel_style.children
        .filter((child) => child.name === Lapel_style_value)[0]
        .children.filter(
          (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
        )[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
        )[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 3).toUpperCase() ===
            hole_Position.substring(0, 3).toUpperCase()
        )[0]
        .children.forEach((child) => (child.visible = false)),
      (Lapel_style.children
        .filter((child) => child.name === Lapel_style_value)[0]
        .children.filter(
          (child) => child.name.substring(0, 4) === "Buttonhole".substring(0, 4)
        )[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 4) === Lapel_buttonhole.substring(0, 4)
        )[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 3).toUpperCase() ===
            hole_Position.substring(0, 3).toUpperCase()
        )[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 1).toUpperCase() ===
            Lapel_width.substring(0, 1).toUpperCase()
        )[0].visible = true));
  }

  // // AMF
  Lapel_style.children
    .filter((child) => child.name === Lapel_style_value)[0]
    .children.filter(
      (child) => child.name.substring(0, 1) === Lapel_width.substring(0, 1)
    )[0]
    .children.forEach(
      (child) =>
        child.name.substring(0, 2) === "mm".substring(0, 2) &&
        (child.visible = true)
    ),
    // AMF_Size !== 'None' && (
    //     Lapel_style.children.filter((child) => child.name === Lapel_style_value)[0].children.filter((child) => child.name.substring(0, 1) === Lapel_width.substring(0, 1))[0].children.filter((child) => child.name.substring(0, 3) === AMF_Size.substring(0, 3))[0].visible = true
    // )
    Lapel_style.children
      .filter((child) => child.name === Lapel_style_value)[0]
      .children.filter(
        (child) => child.name.substring(0, 1) === Lapel_width.substring(0, 1)
      )[0]
      .children.forEach(
        (child) => child.name.substring(0, 2) === "b2" && (child.visible = true)
      );
};
const update_Shoulders = () => {
  Shoulders.children.forEach((child) => (child.visible = false));
  console.log("Shoulder::",Shoulder)
  Shoulders.children.filter(
    (child) => child.name === Shoulder
  )[0].visible = true;
  // Shoulders.children.filter((child) => child.name === 'Unlined001')[0].visible = true;
  update_Vent();
};
const update_Chest_Pocket = () => {
  Chest_Pocket.children.forEach((child) => (child.visible = false));
  Chest_Pocket.children.filter(
    (child) => child.name.substring(0, 4) === Chest_Pocket_value.substring(0, 4)
  )[0].visible = true;
  update_Sleeve_Button();
};
const update_Side_Pocket = () => {
  Side_pocket.children.forEach((child) => (child.visible = false));
  Side_pocket.children.filter(
    (child) =>
      child.name.substring(0, side_pocket_value.length - 3) ===
      side_pocket_value.substring(0, side_pocket_value.length - 3)
  )[0].visible = true;
  // Side_pocket.children.filter((child) => child.name.substring(0, 4) === side_pocket_value.substring(0, 4))[0].visible = true;
  // Ticket_pocket_value = false;
  update_Ticket_pockets();
  update_Sleeve_Button();
};
const update_Ticket_pockets = () => {
  const filter_value = Ticket_pockets.children.filter(
    (child) =>
      child.name.substring(0, side_pocket_value.length - 3) ===
      side_pocket_value.substring(0, side_pocket_value.length - 3)
  );
  Ticket_pockets.children.forEach((child) => (child.visible = false));
  Ticket_pocket_value &&
    filter_value.length > 0 &&
    (filter_value[0].visible = true);

  // document.getElementById("ticket_pocket").disabled = filter_value.length === 0 ? true : false;
};
const update_Vent = () => {
  const bIsShoulderVent_value =
    Shoulders.children.filter((child) => child.name === Shoulder)[0].children
      .length > 0;
  // Vent.children.forEach((child) => child.visible = false);

  Shoulders.children
    .filter((child) => child.name === Shoulder)[0]
    .children.forEach((child) => (child.visible = false));
  Shoulders.children
    .filter((child) => child.name === Shoulder)[0]
    .children.filter(
      (child) => child.name.substring(0, 1) === Vent_value.substring(0, 1)
    )[0].visible = true;
  // Shoulders.children.filter((child) => child.name === Shoulder)[0].children.filter((child) => child.name.substring(0, 3) === Vent_value.substring(0, 3))[0].visible = true;
  // Shoulders.children.filter((child) => child.name === Shoulder)[0].children.filter((child) => child.name.substring(0, 1) === Vent_value.substring(0, 1))[0].children.filter((child) => child.name.substring(0, 3) === 'mm6')[0].visible = AMF_Size.substring(0, 3) === 'mm6'
  // Shoulders.children.filter((child) => child.name === Shoulder)[0].children.filter((child) => child.name.substring(0, 1) === Vent_value.substring(0, 1))[0].children.filter((child) => child.name.substring(0, 3) === 'mm2')[0].visible = AMF_Size.substring(0, 3) === 'mm2'
  // Vent.children.filter((child) => child.name === Vent_value)[0].children.filter((child) => child.name.substring(0, 3) === 'mm6')[0].visible = AMF_Size.substring(0, 3) === 'mm6'
  // Vent.children.filter((child) => child.name === Vent_value)[0].children.filter((child) => child.name.substring(0, 3) === 'mm2')[0].visible = AMF_Size.substring(0, 3) === 'mm2'
};
const update_Lining = () => {
  Lining.children.forEach((child) => (child.visible = false));
  Lining.children.filter(
    (child) =>
      child.name.substring(0, 3).toUpperCase() ===
      Lining_value.substring(0, 3).toUpperCase()
  )[0].visible = true;
  Lining.children[2].visible = true;
};
// update_Sleeve_Button
const update_Sleeve_Button = () => {
  buttons.children.forEach((child) =>
    child.children.forEach((child) => (child.visible = false))
  );

  buttons.children[1].children.filter(
    (child) => child.name === Sleeve_Button_value
  )[0].visible = true;
  buttons.children[0].children[0].visible =
    Chest_Pocket_value === "pleat_B" ? true : false;

  buttons.children[2].children[0].visible =
    side_pocket_value === "Pleat_Patch" ? true : false;
  buttons.children[3].children[0].visible = true;

  buttons.children[1].children.filter(
    (child) => child.name === Sleeve_Button_value
  )[0].children[1].visible = false;
};
const update_Cuffed_sleeve = () => {
  Shoulders.children.filter(
    (child) => child.name === "Cuffed_sleeve"
  )[0].visible = Cuffed_sleeve_value;
  // Shoulders.children.filter((child) => child.name === 'Cuffed_sleeve')[0].children[1].visible = AMF_Size.substring(0, 3) === 'mm6';
  // Shoulders.children.filter((child) => child.name === 'Cuffed_sleeve')[0].children[0].visible = AMF_Size.substring(0, 3) === 'mm2';
};

// All Functions for Taxido Trouser

const update_Hem_finishing = () => {
  // const Hem_finishing_value = document.getElementById("Hem_finishing").value;
  hemFinishing.children.forEach((child) => (child.visible = false));
  Hem_finishing_value !== "None" &&
    (hemFinishing.children.filter(
      (child) => child.name === Hem_finishing_value
    )[0].visible = true);
};
const update_Pleats = () => {
  // const Pleat = document.getElementById("Pleats").value;
  pleats.children.forEach((child) => (child.visible = false));
  pleats.children.filter((child) => child.name === Pleat)[0].visible = true;
  // pleats.children.filter((child) => child.name === Pleat)[0].material.transparent = true;
  // pleats.children.filter((child) => child.name === Pleat)[0].material.depthWrite = true;
};
const update_side_Pockets = () => {
  // const pocket_side = document.getElementById("Side_Pocket").value;
  // const AMF_Size = document.getElementById("AMF").value;

  side_Pockets.children.forEach((child) => (child.visible = false));
  side_Pockets.children.filter(
    (child) => child.name === pocket_side
  )[0].visible = true;
  side_Pockets.children
    .filter((child) => child.name === pocket_side)[0]
    .children.forEach((child) => (child.visible = false)),
    TAMF_Size !== "None" &&
      (side_Pockets.children
        .filter((child) => child.name === pocket_side)[0]
        .children.filter(
          (child) => child.name.substring(0, 5) === TAMF_Size
        )[0].visible = true);
};
const update_Back_Pockets = () => {
  // const pockets_back = document.getElementById("Back_pockets").value;
  back_Pockets.children.forEach((child) => (child.visible = false));
  back_Pockets.children.filter(
    (child) => child.name === pockets_back
  )[0].visible = true;
};
const update_Coin_Pocket = () => {
  if (coin_pocket_value == true) {
    coin_Pocket.children[0].visible = true;
  } else {
    coin_Pocket.children[0].visible = false;
  }
  // coin_Pocket.children[0].visible = document.getElementById("Coin_Pocket").checked;
};
const update_Waistband = () => {
  // const waistband_value = document.getElementById("Waistband").value;
  // const waistband_height = document.getElementById("Waistband_height").value;
  const isOscar = waistband_value.substring(0, 4) === "Oscar".substring(0, 4);

  waistband.children.forEach((child) =>
    child.children.forEach((child) => (child.visible = false))
  );
  waistband.children.filter(
    (child) => child.name === waistband_value
  )[0].visible = true;
  // waistband.children.filter((child) => child.name === waistband_value)[0].children[0].visible = true;
  waistband.children.filter(
    (child) => child.name === waistband_value
  )[0].children[isOscar ? waistband_height : 0].visible = true;
  waistband.children.filter(
    (child) => child.name === "Gurkha"
  )[0].children[0].children[4].visible = false;
  update_Fasteting();
};
const TupdateMaterialFabric = (fabric) => {
  curruntFabric = fabric;
  getColorIntensityCategory(fabric.color_r, fabric.color_g, fabric.color_b);
  TupdateMaterialTextures(side_Pockets.children[0].material, fabric);
  TupdateMaterialTextures(fasteting.children[0].material, fabric);
  TupdateMaterialTextures(pleats.children[0].children[1].material, fabric);
  TupdateTuxedoColor();
  side_Pockets.children[0].children[0].material.color = "#888888";
};
function TupdateTuxedoColor() {
  // const colorTuxedo = document.getElementById("color_tuxedo").value;
  if (colorTuxedo === "None") {
    TupdateMaterialFabric(
      pleats.children[0].children[1].material,
      curruntFabric
    );
    pleats.children[0].children[1].material.color.setRGB(1, 1, 1);
    pleats.children[0].children[1].material.emissive.setRGB(0, 0, 0);
  } else {
    // pleats.children[0].children[1].material.color.setRGB(1, 1, 1);
    pleats.children[0].children[1].material.color.set(colorTuxedo);
    // add emissive color
    pleats.children[0].children[1].material.emissive.set(colorTuxedo);
    pleats.children[0].children[1].material.roughness = 0.85;
  }
}
const WupdateMaterialFabric = (fabric) => {
    const textureLoader = new THREE.TextureLoader();
    const updateMaterialTextures = (material) => {
        const loadTexture = (url, callback) => {
            textureLoader.load(url, (texture) => {
                callback(texture);
                material.needsUpdate = true;
            });
        };

        if (fabric.repeatable_metalness_image_url) {
            loadTexture(fabric.repeatable_metalness_image_url, (texture) => {
                material.metalnessMap = texture;
            });
        }

        // Load and set roughness map
        if (fabric.repeatable_roughness_image_url) {
            loadTexture(fabric.repeatable_roughness_image_url, (texture) => {
                material.roughnessMap = texture;
            });
        }
        if (fabric.repeatable_displacement_image_url) {
            loadTexture(fabric.repeatable_displacement_image_url, (texture) => {
                material.displacement = texture;
            });
        }
        if (fabric.repeatable_normal_image_url) {
            loadTexture(fabric.repeatable_normal_image_url, (texture) => {
                material.normal = texture;
            });
        }
        if (fabric.repeatable_rma_image_url) {
            loadTexture(fabric.repeatable_rma_image_url, (texture) => {
                material.rma = texture;
            });
        }
        if (fabric.repeatable_specular_image_url) {
            loadTexture(fabric.repeatable_specular_image_url, (texture) => {
                material.specular = texture;
            });
        }
        if (fabric.repeatable_ao_image_url) {
            loadTexture(fabric.repeatable_ao_image_url, (texture) => {
                material.ao = texture;
            });
        }

        const waistcoatColorUrl =
            fabric.repeatable_color_image_url || DEFAULT_FABRIC_TEXTURE_URL;
        if (waistcoatColorUrl) {
            loadTexture(waistcoatColorUrl, (texture) => {
                texture.encoding = THREE.sRGBEncoding;
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                const tilingX =
                    ((fabric.tiling_info &&
                        fabric.tiling_info.color_tiling_x) ||
                        1) * 0.5;
                const tilingY =
                    ((fabric.tiling_info &&
                        fabric.tiling_info.color_tiling_y) ||
                        1) * 0.5;
                texture.repeat.set(tilingX, tilingY);
                material.map = texture;
            });
        }

        material.displacementScale = fabric.displacement_scale || 0;
        material.metalness = fabric.metalness || 0;
        material.roughness = fabric.roughness || 1;
        material.specular_value = fabric.specular_value || 0;
        material.shininess = fabric.shininess;
        material.needsUpdate = true;
    };
    updateMaterialTextures(WCollar_Styles.children[7].children[0].material);

    getColorIntensityCategory(fabric.color_r, fabric.color_g, fabric.color_b);
    WCollar_Styles.children[0].children[6].material.roughness = 1;
    model.visible = true;
};

// For Waistcoat

const updateSidePockets = () => {
  WSide_pocket.children.forEach((child) => (child.visible = false));
  WSide_pocket.children.find(
    (child) => child.name === twpocketSide
  ).visible = true;
};
const updateChestPockets = () => {
  WChest_Pocket.children.forEach((child) => (child.visible = false));
  if (twpocketsBack !== "No_pocket" && isHorseStyle) {
    WChest_Pocket.children.find(
      (child) => child.name === twpocketsBack
    ).visible = true;
  }
  // document.getElementById("Chest_Pocket").disabled = !isHorseStyle;
};

const updateCollarStyles = () => {
  WCollar_Styles.children.forEach((child) => (child.visible = false));
  if (twcollarStyle === "Horse") {
    let Horsevalue;
    switch (twbuttoning) {
      case "Single_Breasted_5_V_Shape":
        Horsevalue = "Horse_shoe_SB_5";
        break;
      case "Single_Breasted_4_V_Shape":
        Horsevalue = "Horse_shoe_SB_4";
        break;
      case "Single_Breasted_6_V_Shape":
        Horsevalue = "Horse_shoe_SB_6";
        break;
      case "Double_Breasted_6_button_V":
        Horsevalue = "Horse_shoe_DB_6";
        break;
    }
    WCollar_Styles.children.filter(
      (child) => child.name === Horsevalue
    )[0].visible = true;
  } else {
    // WCollar_Styles.children.filter((child) => child.name === twbuttoning)[0].children.forEach((child) => (child.visible = false));
    WCollar_Styles.children
      .filter((child) => child.name === twbuttoning)[0]
      .children.forEach(
        (child) =>
          (child.name.substring(0, 5) === "Notch" ||
            child.name.substring(0, 4) === "Peak" ||
            child.name.substring(0, 4) === "shawlLapel_D".substring(0, 4)) &&
          (child.visible = false)
      );
    WCollar_Styles.children.filter(
      (child) => child.name === twbuttoning
    )[0].visible = true;
    twcollarStyle !== "None" &&
      (WCollar_Styles.children
        .filter((child) => child.name === twbuttoning)[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 4) === twcollarStyle.substring(0, 4)
        )[0].visible = true);
    // AMF Size
    WCollar_Styles.children
      .filter((child) => child.name === twbuttoning)[0]
      .children.forEach(
        (child) =>
          (child.name.substring(0, 5) === "Notch" ||
            child.name.substring(0, 4) === "Peak" ||
            child.name.substring(0, 4) === "shawlLapel_D".substring(0, 4)) &&
          child.children.forEach(
            (child) =>
              child.name.substring(0, 3) === "AMF" && (child.visible = false)
          )
      );
    twcollarStyle !== "None" &&
      WCollar_Styles.children
        .filter((child) => child.name === twbuttoning)[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 4) === twcollarStyle.substring(0, 4)
        )[0]
        .children.filter(
          (child) =>
            child.name.substring(0, 5) === amfSize && (child.visible = true)
        );
  }
};
const updateBackColor = (backColor) => {
  // twcolorFabric.style.display = twbackStyle !== 'Fabric' ? "block" : "none";

  if (backFabrics) {
    model.children[0].children[3].material.metalness = 1;
    model.children[0].children[3].material.roughness = 1;
  }

  model.children[0].children[0].visible = twbackStyle === "Fabric";
  model.children[0].children[3].visible = twbackStyle === "Lining";

  model.children[0].children[3].material.color.set(backColor);
  model.children[0].children[3].material.roughness = 2;

  model.children[0].children[3].material.needsUpdate = true;

  // console.log(model.children[0].children[3].material);
};

//Fasteting
const update_Fasteting = () => {
  fasteting.children.forEach((child) => (child.visible = false));

  // fasteting_value.options[1].disabled = false

  if (waistband_value.substring(0, 4) !== "Oscar".substring(0, 4)) {
    if (waistband_value !== "Butterfly") {
      return;
    } else {
      // fasteting_value.options[1].disabled = true
    }
  }

  if (fasteting_value === "Belt" && fasteting_value !== "None") {
    fasteting.children[waistband_height].visible = true;
  } else {
    fasteting_value !== "None" &&
      (fasteting.children.filter(
        (child) => child.name === fasteting_value
      )[0].visible = true);
    // fasteting_value !== 'None' && (console.log(fasteting.children.filter((child) => child.name === fasteting_value)[0].position.y = (waistband_height / 40)));
  }
  fasteting.children[waistband_height].children[0].visible =
    waistband_value.split("_")[2] !== "Extended" && fasteting_value === "Belt";
};

let previousSelectedDiv = null;
let price;
let fprice;
let metperperproduct;
let cmt;
let markupprice;
let finalprice;
if (dataPageValue == "custom-made-tuxedo-jacket") {
  metperperproduct = 2;
  cmt = 1250;
  markupprice = 2000;
} else if (dataPageValue == "custom-made-tuxedo-trouser") {
  metperperproduct = 1.5;
  cmt = 310;
  markupprice = 1000;
} else if (dataPageValue == "custom-made-tuxedo-waistcoat") {
  metperperproduct = 0.9;
  cmt = 470;
  markupprice = 950;
}

// api
async function fetchFabrics() {
    const response = await axios.get(
        "https://grand-le-mar.lc.webdevprojects.cloud/api/v1/fetch/fabrics"
    );
    allfabrics = response.data.data;
    console.log("defaultfabriccode", defaultfabriccode);
    const fid = response.data.data?.filter(
        (fabric) => fabric.id === defaultfabriccode
    );
    // sCurruntFabric = fid[0];
    sCurruntFabric = null;

    if (
        dataPageValue == "custom-made-tuxedo-trouser" ||
        trouserdiv.classList.contains("isSelected")
    ) {
        model && TupdateMaterialFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
    } else if (
        dataPageValue == "custom-made-tuxedo-waistcoat" ||
        waistecoatdiv.classList.contains("isSelected")
    ) {
        model && WupdateMaterialFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
    } else {
        model && updateMaterialFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
    }
}
function ShowFabrics(fabrics) {
  const container = document.getElementById("fabric-container");
  // console.log(container)
  fabrics.forEach((fabric) => {
    if (fabric.repeatable_color_image_url) {
      const fabricDiv = document.createElement("div");
      fabricDiv.className = "fabric-div";

      // Create an image element
      const img = document.createElement("img");
      img.src = fabric.repeatable_color_image_url;
      img.alt = fabric.id;
      img.className = "fabric-image";

      const idDiv = document.createElement("div");
      idDiv.innerText = fabric.serial_number;
      idDiv.className = "fabric-serial_number";

      const priceDiv = document.createElement("div");
      priceDiv.innerText = fabric.price_per_yard;
      priceDiv.className = "fabric-price";

      fabricDiv.appendChild(img);
      fabricDiv.appendChild(idDiv);
      fabricDiv.appendChild(priceDiv);

      container.appendChild(fabricDiv);
      img.addEventListener("click", () => {
        // console.log(fabric)
        sCurruntFabric = fabric;
        // console.log(model)
        fprice = fabric.price_per_yard;
        finalprice = (fprice * metperperproduct + cmt + markupprice) * 1.25;
        // console.log(fprice)
        price = document.getElementsByClassName("price")[0];
        // console.log(price)
        price.innerHTML = finalprice + " Kr.";
        if (
          dataPageValue == "custom-made-tuxedo-trouser" ||
          trouserdiv.classList.contains("isSelected") ||
          trouseractive
        ) {
          TupdateMaterialFabric(fabric);
        } else if (
          dataPageValue == "custom-made-tuxedo-waistcoat" ||
          waistecoatdiv.classList.contains("isSelected") ||
          waistcoatactive
        ) {
          WupdateMaterialFabric(fabric);
        } else {
          updateMaterialFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
        }
        // updateMaterialFabric(fabric);
        // fetchFabricsByid(fabric.id);

        // // console.log(fabric);
      });
    }
  });
  if (document.body.classList.contains("line-loading")) {
    document.body.classList.remove("line-loading");
  }
}
async function fetchFabricsByid(fabric_id) {
  const response = await axios.get(
    `https://api.tg3ds.com/api/v1/fabrics/${fabric_id}/?apikey=${"QaLQzsUNDDcXVPZei0p3fegHMD7AzhJpFoct"}`
  );
  // console.log(response.data);
  updateMaterialFabric(response.data);
}

// let jacketdiv = document.querySelectorAll('.cm-progress-container[data-progress="jacket-design"]')[0];
// let trouserdiv = document.querySelectorAll('.cm-progress-container[data-progress="trouser-design"]')[0];
// let waistecoatdiv = document.querySelectorAll('.cm-progress-container[data-progress="waistcoat-design"]')[0];
// console.log(trouserdiv);
// $(document).on("click", ".btn-customize.next_button, .btm_tab .cm-toggle-item", function() {
// //     console.log("clicked")
//     setTimeout(() => {
//         if (trouserdiv.classList.contains("isSelected")) {
// //           console.log("Trouser Loaded")
//           loadGLTFmoadl('Trousere');
//         }
//         else if (waistecoatdiv.classList.contains("isSelected")) {
//           loadGLTFmoadl('Waistcoat');
//         }
//         else if (waistecoatdiv.classList.contains("isSelected")) {
//           loadGLTFmoadl(intialmodel);
//         }
//     }, 100);

// });
// Load other models in the background
function loadOtherModels() {
  // Add conditions to load other models based on your requirements
  // For example, load a model if the initial model is loaded
  loadGLTFmoadl("taxido-button-2");
  loadGLTFmoadl("taxido-button-4");
  loadGLTFmoadl("taxido-button-6");
  loadGLTFmoadl("taxido-button-7");
}

// Trigger loading of other models in the background
// loadOtherModels();

$(document).on(
  "click",
  ".btn-customize.next_button, .btm_tab .cm-toggle-item",
  function () {

    setTimeout(() => {
      if (trouserdiv.classList.contains("isSelected")) {
        // document.body.classList.add("line-loading-3d-preview");
        // console.log("Trouser Loaded")
        //loadLodingText();
        loadGLTFmoadl("Tuxedo_Trousers");

        // updateMaterialFabricTrouser(sCurruntFabric);
        trouseractive = true;
        jacketactive = false;
        waistcoatactive = false;

        // console.log(sCurruntFabric)
      } else if (waistecoatdiv.classList.contains("isSelected")) {
        // document.body.classList.add("line-loading-3d-preview");
        //loadLodingText();
        loadGLTFmoadl("Tuxedo_waistcoat");
        waistcoatactive = true;
        trouseractive = false;
        jacketactive = false;
      } else if (jacketdiv.classList.contains("isSelected")) {
        // document.body.classList.add("line-loading-3d-preview");

        loadGLTFmoadl(intialmodel);

        jacketactive = true;
        waistcoatactive = false;
        trouseractive = false;
      }
      // modelvales()
    }, 100);
  }
);

// .btn-customize.next_button
$(document).on("click", ".btn-customize.next_button", function () {});
$(document).on(
  "click",
  ".cm-modifier-drawer[drawer-type='one'] .drawer1_apply, .cm-modifier-drawer .drawer2_apply, .cm-toggle-ele .cm-toggle-item,.btm_tab .cm-toggle-item",
  function (event) {
    var currObj = this;

    // Added by softpulse
    if($(currObj).parents(".isSelected").find(".is-selected").hasClass("cm-drawer-other-option-btn")){
      $("body").removeClass("line-loading-3d-preview");
      currObj.classList.contains("inactive_button") ? currObj.classList.remove("inactive_button") : '';
      return;
    }

    if(event.isTrigger){
      modelvales(currObj);
      //$(this).hasClass("inactive_button") ? $(this).removeClass("inactive_button") : '';
    }
    // setTimeout(() => {
    //     // Get all the parent divs with the class "cm-modifier-card-container"
    //     let parentDivs = document.querySelectorAll('.cm-modifier-card-container');
    //     let resultTitleText, resultTitleTextWithoutSpaces, childDiv, resultTitleDiv

    //     if (dataPageValue == 'custom-made-tuxedo-jacket') {
    //         // Iterate through each parent div for Trouser model
    //         for (let i = 0; i < parentDivs.length; i++) {
    //               // Get the child div with the class "cm-modifier-card-wrapper"
    //               childDiv = parentDivs[i].querySelector('.cm-modifier-card-wrapper');
    //               // Check if the child div exists
    //               if (childDiv) {
    //                   // Access data or perform actions on the child div
    //                   console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper

    //                   // Find the children div with class "cm-modifier-result-title" within childDiv
    //                   resultTitleDiv = childDiv.querySelector('.cm-modifier-result-title');

    //                   if (resultTitleDiv) {
    //                       resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
    //                       resultTitleTextWithoutSpaces = resultTitleText.replace(/[.\s:]+/g, '_'); // Replace spaces and dots with underscores
    //                       // console.log("Result Title: " + resultTitleTextWithoutSpaces); // Log the modified text content
    //                   }
    //                   if (i == 0) {
    //                       if (resultTitleTextWithoutSpaces == 'Single_Breasted_1_button') {
    //                           resultTitleTextWithoutSpaces = 'taxido-button-1';
    //                       }
    //                     else if (resultTitleTextWithoutSpaces == 'Single_Breasted_2_button') {
    //                           resultTitleTextWithoutSpaces = 'taxido-button-2';
    //                       }
    //                     else if (resultTitleTextWithoutSpaces == 'Double_Breasted_4_button') {
    //                           resultTitleTextWithoutSpaces = 'taxido-button-4';
    //                       }
    //                     else if (resultTitleTextWithoutSpaces == 'Double_Breasted_6_button') {
    //                           resultTitleTextWithoutSpaces = 'taxido-button-6';
    //                       }
    //                     else if (resultTitleTextWithoutSpaces == 'Double_Breasted_6_button_low') {
    //                           resultTitleTextWithoutSpaces = 'taxido-button-7';
    //                       }
    //                       let activediv = childDiv.querySelector('.cm-modifier-card-content');
    //                       if (activediv.classList.contains("active-option")) {
    //                           // // console.log(newresultTitleDiv);
    //                         loadLoader();
    //                         // console.log(resultTitleTextWithoutSpaces)
    //                         loadGLTFmoadl(resultTitleTextWithoutSpaces);
    //                         // scene.children.forEach(child => {
    //                         //     // Check if the child corresponds to any model from the loadedModels array
    //                         //     if (Object.values(loadedModels).includes(child)) {
    //                         //         // Remove the child from the scene
    //                         //         scene.remove(child);
    //                         //     }
    //                         // });

    //                         // // Add the new model to the scene if it exists in the loadedModels array
    //                         // if (loadedModels[resultTitleTextWithoutSpaces]) {
    //                         //     scene.add(loadedModels[resultTitleTextWithoutSpaces]);
    //                         // }
    //                       }
    //                   }
    //                   if (i == 1) {
    //                       if (resultTitleTextWithoutSpaces == 'Peak') {
    //                           resultTitleTextWithoutSpaces = 'peak';
    //                       }
    //                     else if (resultTitleTextWithoutSpaces == 'Shawl') {
    //                           resultTitleTextWithoutSpaces = 'Shawl';
    //                       }
    //                     Lapel_style_value = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 2) {
    //                     if (resultTitleTextWithoutSpaces == 'Black_satin') {
    //                       resultTitleTextWithoutSpaces = 'black'
    //                     } else if (resultTitleTextWithoutSpaces == 'Navy_satin') {
    //                       resultTitleTextWithoutSpaces = 'blue'
    //                     } else if (resultTitleTextWithoutSpaces == 'White_satin') {
    //                       resultTitleTextWithoutSpaces = 'white'
    //                     } else {
    //                       resultTitleTextWithoutSpaces = 'None'
    //                     }
    //                     sTuxedoColor = resultTitleTextWithoutSpaces;
    //                     console.log(sTuxedoColor)
    //                                           updateTuxedoColor();

    //                   }
    //                   if (i == 3) {
    //                     if (resultTitleTextWithoutSpaces == 'Narrow') {
    //                           resultTitleTextWithoutSpaces = 'narrow';
    //                       }
    //                      else if (resultTitleTextWithoutSpaces == 'Standard') {
    //                           resultTitleTextWithoutSpaces = 'standard';
    //                       }
    //                     else if (resultTitleTextWithoutSpaces == 'Wide') {
    //                           resultTitleTextWithoutSpaces = 'wide';
    //                       }
    //                     Lapel_width  = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 4) {
    //                     if (resultTitleTextWithoutSpaces == 'Double') {
    //                           resultTitleTextWithoutSpaces = 'double';
    //                       }
    //                      else if (resultTitleTextWithoutSpaces == 'Single') {
    //                           resultTitleTextWithoutSpaces = 'single';
    //                       }
    //                     else if (resultTitleTextWithoutSpaces == 'None') {
    //                           resultTitleTextWithoutSpaces = 'none';
    //                       }
    //                       Vent_value = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 4) {

    //                   }
    //                   if (i == 5) {

    //                   }
    //                   if (i == 6) {
    //                       if (resultTitleTextWithoutSpaces == 'Rope_Shoulder_-_Structured_(5_mm)') {
    //                         resultTitleTextWithoutSpaces = 'Rounded_Shoulder_5mm'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Rope_Shoulder_-_Lightly_Padded_(2_mm)') {
    //                          resultTitleTextWithoutSpaces = 'Rounded_Shoulder_5mm'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Natural_Shoulder_-_Structured_(5_mm)') {
    //                         resultTitleTextWithoutSpaces = 'Natural_Shoulder_5mm'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Natural_Shoulder_-_Lightly_Padded_(2_mm)') {
    //                         resultTitleTextWithoutSpaces = 'Natural_Shoulder_2mm'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Natural_Shoulder_-_Unconstructed_(0_mm)') {
    //                         resultTitleTextWithoutSpaces = 'Natural_Shoulder_0mm'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'La_Spalla_Camicia_-_Unconstrcuted_(2_mm)') {
    //                           resultTitleTextWithoutSpaces = 'spalla_camicia_2mm'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'La_Spalla_Camicia_-_Unconstrcuted_(0_mm)') {
    //                           resultTitleTextWithoutSpaces = 'spalla_camicia_0mm'
    //                       }
    //                       Shoulder = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 7) {
    //                       if (resultTitleTextWithoutSpaces == '2_mm_(Standard)') {
    //                         resultTitleTextWithoutSpaces = 'mm2'
    //                       } else if (resultTitleTextWithoutSpaces == '6_mm') {
    //                           resultTitleTextWithoutSpaces = 'mm6'
    //                       }
    //                       AMF_Size = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 8) {
    //                       if (resultTitleTextWithoutSpaces == 'Boat') {
    //                         resultTitleTextWithoutSpaces = 'Boat_Shape'
    //                       } else if (resultTitleTextWithoutSpaces == 'Patch') {
    //                           resultTitleTextWithoutSpaces = 'patch'
    //                       } else if (resultTitleTextWithoutSpaces == 'Rounded_patch') {
    //                           resultTitleTextWithoutSpaces = 'Rounded'
    //                       } else if (resultTitleTextWithoutSpaces == 'Pleat_patch') {
    //                           resultTitleTextWithoutSpaces = 'pleat_B'
    //                       }
    //                       Chest_Pocket_value = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 9) {
    //                     if (resultTitleTextWithoutSpaces == 'Slanted_Flap') {
    //                         resultTitleTextWithoutSpaces = 'Slanted_Flap001'
    //                     } else if (resultTitleTextWithoutSpaces == 'Jetted') {
    //                         resultTitleTextWithoutSpaces = 'Jetted001'
    //                     } else if (resultTitleTextWithoutSpaces == 'Slanted_Jetted') {
    //                         resultTitleTextWithoutSpaces = 'Slanted_Jetted001'
    //                     }
    //                     side_pocket_value = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 10) {
    //                     if (resultTitleTextWithoutSpaces == 'Yes') {
    //                         Ticket_pocket_value = true;
    //                     } else {
    //                         Ticket_pocket_value = false;
    //                     }
    //                   }
    //                   if (i == 12) {
    //                     if (resultTitleTextWithoutSpaces == 'Yes') {
    //                       Cuffed_sleeve_value = true;
    //                     }
    //                     else {
    //                       Cuffed_sleeve_value = false;
    //                     }
    //                   }
    //                   if (i == 13) {
    //                     if (resultTitleTextWithoutSpaces == '3_kissing') {
    //                         resultTitleTextWithoutSpaces = 'kissing_3'
    //                     } else if (resultTitleTextWithoutSpaces == '3_non-kissing') {
    //                         resultTitleTextWithoutSpaces = 'non_kissing_3'
    //                     } else if (resultTitleTextWithoutSpaces == '4_kissing_(Standard)') {
    //                         resultTitleTextWithoutSpaces = 'kissing_4'
    //                     } else if (resultTitleTextWithoutSpaces == '4_non-kissing') {
    //                         resultTitleTextWithoutSpaces = 'non_kissing_4'
    //                     } else if (resultTitleTextWithoutSpaces == '5_kissing_special_(Tom_Ford)') {
    //                         resultTitleTextWithoutSpaces = 'kissing_5'
    //                     } else if (resultTitleTextWithoutSpaces == '5_non-kissing') {
    //                         resultTitleTextWithoutSpaces = 'non_kissing_5'
    //                     } else if (resultTitleTextWithoutSpaces == '1_sleeve_button') {
    //                         resultTitleTextWithoutSpaces = 'sleeve_button_1'
    //                     }
    //                     Sleeve_Button_value = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 14) {
    //                       if (resultTitleTextWithoutSpaces == 'Left_(Standard)') {
    //                           resultTitleTextWithoutSpaces = 'right'
    //                       } else if (resultTitleTextWithoutSpaces == 'Right') {
    //                           resultTitleTextWithoutSpaces = 'left'
    //                       }
    //                       hole_Position = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 15) {
    //                     if (resultTitleTextWithoutSpaces == 'Traditional') {
    //                       resultTitleTextWithoutSpaces = 'Handmade'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Handmade_milanese') {
    //                       resultTitleTextWithoutSpaces = 'Traditional'
    //                     }
    //                     Lapel_buttonhole = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 16) {
    //                      if (resultTitleTextWithoutSpaces == 'Half_Lined') {
    //                         resultTitleTextWithoutSpaces = 'halfline'
    //                     } else if (resultTitleTextWithoutSpaces == 'Fully_Lined') {
    //                         resultTitleTextWithoutSpaces = 'full'
    //                     }
    //                     Lining_value = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 16) {

    //                   }
    //                   update_Lapel_width();
    //                   update_Shoulders();
    //                   update_Side_Pocket();
    //                   update_Ticket_pockets();
    //                   update_Vent();
    //                   update_Lining();
    //                   update_Sleeve_Button();
    //                   update_Chest_Pocket();
    //                   update_Cuffed_sleeve(Cuffed_sleeve_value)

    //               }
    //           }

    //     }
    //     else if (dataPageValue == 'custom-made-tuxedo-trouser') {
    //           // Iterate through each parent div for Waistcoat model
    //           for (let i = 0; i < parentDivs.length; i++) {
    //                 // Get the child div with the class "cm-modifier-card-wrapper"
    //                 childDiv = parentDivs[i].querySelector('.cm-modifier-card-wrapper');
    //                 // Check if the child div exists
    //                 if (childDiv) {
    //                     // Access data or perform actions on the child div
    //                     // console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper

    //                     // Find the children div with class "cm-modifier-result-title" within childDiv
    //                     resultTitleDiv = childDiv.querySelector('.cm-modifier-result-title');

    //                     if (resultTitleDiv) {
    //                         resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
    //                         resultTitleTextWithoutSpaces = resultTitleText.replace(/[.\s:]+/g, '_'); // Replace spaces and dots with underscores
    //                         // console.log("Result Title: " + resultTitleTextWithoutSpaces); // Log the modified text content
    //                     }
    //                     if (i == 0) {
    //                       if (resultTitleTextWithoutSpaces == 'Oscar_Straight_[7_cm_overlap]') {
    //                         resultTitleTextWithoutSpaces = 'Oscar_Straight'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Oscar_Straight_Extended_[11_cm_overlap]') {
    //                         resultTitleTextWithoutSpaces = 'Oscar_Straight_Extended'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Oscar_Straight_Extended_[11_cm_overlap]') {
    //                         resultTitleTextWithoutSpaces = 'Oscar_Straight_Extended'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Oscar_Peak_[7_cm_overlap]') {
    //                         resultTitleTextWithoutSpaces = 'Oscar_Peak'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Oscar_Peak_Extended_[11_cm_overlap]') {
    //                         resultTitleTextWithoutSpaces = 'Oscar_Peak_Extended'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Drawstring') {
    //                         resultTitleTextWithoutSpaces = 'DrawString'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Original_Gurkha') {
    //                         resultTitleTextWithoutSpaces = 'Gurkha_double'
    //                       }
    //                       waistband_value = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 1) {
    //                       if (resultTitleTextWithoutSpaces == 'None') {
    //                           resultTitleTextWithoutSpaces = 'None'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Belt_Loop') {
    //                           resultTitleTextWithoutSpaces = 'Belt';
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Side-adjusters') {
    //                           resultTitleTextWithoutSpaces = 'Side_adjusters_';
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Lowered_Side-adjusters') {
    //                           resultTitleTextWithoutSpaces = 'Lower_Side_adjusters';
    //                       }
    //                       fasteting_value = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 2) {
    //                       if (resultTitleTextWithoutSpaces == '3_5_cm') {
    //                         resultTitleTextWithoutSpaces = '0'
    //                       } else if (resultTitleTextWithoutSpaces == '4_cm') {
    //                         resultTitleTextWithoutSpaces = '1'
    //                       } else if (resultTitleTextWithoutSpaces == '5_cm') {
    //                         resultTitleTextWithoutSpaces = '2'
    //                       }
    //                       waistband_height = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 3) {
    //                     if (resultTitleTextWithoutSpaces == 'Yes') {
    //                         coin_pocket_value = true;
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'No') {
    //                         coin_pocket_value = false;
    //                     }
    //                   }
    //                   if (i == 4) {

    //                   }
    //                   if (i == 5) {
    //                      if (resultTitleTextWithoutSpaces == 'No_pleats') {
    //                       resultTitleTextWithoutSpaces = 'Normal_straight_pant'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Outward_Single_Pleats'){
    //                         resultTitleTextWithoutSpaces = 'Standardsinglee'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Outward_Double_Pleats'){
    //                         resultTitleTextWithoutSpaces = 'StandardDouble'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Inward_Single_Pleats'){
    //                         resultTitleTextWithoutSpaces = 'INWARDSINGLE'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Inward_Double_Pleats'){
    //                         resultTitleTextWithoutSpaces = 'INWARDDouble'
    //                     }
    //                     Pleat = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 6) {
    //                     if (resultTitleTextWithoutSpaces == 'Plain') {
    //                       resultTitleTextWithoutSpaces = 'None'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Turn_up_6_cm/_XX_inches_'){
    //                         resultTitleTextWithoutSpaces = 'HemFinishing6CM'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Turn_up_5_cm_/_XX_inches_(Standard)'){
    //                         resultTitleTextWithoutSpaces = 'HemFinishing5CM'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Turn_up_4_cm/_XX_inches_'){
    //                         resultTitleTextWithoutSpaces = 'HemFinishing4CM'
    //                     }
    //                     Hem_finishing_value = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 7) {
    //                     if (resultTitleTextWithoutSpaces == '2_mm_(Standard)') {
    //                       resultTitleTextWithoutSpaces = 'AMF_2'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == '6_mm'){
    //                         resultTitleTextWithoutSpaces = 'AMF_6'
    //                     }
    //                     TAMF_Size = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 8) {
    //                     pocket_side = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 9) {
    //                     if (resultTitleTextWithoutSpaces == 'Black_satin') {
    //                       resultTitleTextWithoutSpaces = '#000000'
    //                     } else if (resultTitleTextWithoutSpaces == 'Navy_satin') {
    //                       resultTitleTextWithoutSpaces = '#34394a'
    //                     } else if (resultTitleTextWithoutSpaces == 'White_satin') {
    //                       resultTitleTextWithoutSpaces = '#a8a8a8'
    //                     } else if (resultTitleTextWithoutSpaces == 'Only_fabric') {
    //                       resultTitleTextWithoutSpaces = 'None'
    //                     }
    //                     colorTuxedo = resultTitleTextWithoutSpaces;
    //                     console.log(sTuxedoColor)
    //                   }
    //                   if (i == 10) {
    //                     if (resultTitleTextWithoutSpaces == 'Jetted') {
    //                       resultTitleTextWithoutSpaces = 'jetted_Button'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Jetted_No_Button') {
    //                         resultTitleTextWithoutSpaces = 'jetted_no_Button'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Jetted_No_Button') {
    //                       resultTitleTextWithoutSpaces = 'jetted_no_Button'
    //                     }
    //                     pockets_back = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 11) {

    //                   }
    //                   // if (i == 3) {
    //                   //   if (resultTitleTextWithoutSpaces == 'No_pleats') {
    //                   //     resultTitleTextWithoutSpaces = 'Normal_straight_pant'
    //                   //   }
    //                   //   else if(resultTitleTextWithoutSpaces == 'Outward_Single_Pleats'){
    //                   //       resultTitleTextWithoutSpaces = 'Standardsinglee'
    //                   //   }
    //                   //   else if(resultTitleTextWithoutSpaces == 'Outward_Double_Pleats'){
    //                   //       resultTitleTextWithoutSpaces = 'StandardDouble'
    //                   //   }
    //                   //   else if(resultTitleTextWithoutSpaces == 'Inward_Single_Pleats'){
    //                   //       resultTitleTextWithoutSpaces = 'INWARDSINGLE'
    //                   //   }
    //                   //   else if(resultTitleTextWithoutSpaces == 'Inward_Double_Pleats'){
    //                   //       resultTitleTextWithoutSpaces = 'INWARDDouble'
    //                   //   }
    //                   //   Pleat = resultTitleTextWithoutSpaces;
    //                   // }
    //                   // if (i == 4) {
    //                   //   if (resultTitleTextWithoutSpaces == 'Plain') {
    //                   //     resultTitleTextWithoutSpaces = 'None'
    //                   //   }
    //                   //   else if(resultTitleTextWithoutSpaces == 'Turn_up_6_cm_/_2_4_inches_'){
    //                   //       resultTitleTextWithoutSpaces = 'HemFinishing6CM'
    //                   //   }
    //                   //   else if(resultTitleTextWithoutSpaces == 'Turn_up_5_cm_/_2_inches_(Standard)'){
    //                   //       resultTitleTextWithoutSpaces = 'HemFinishing5CM'
    //                   //   }
    //                   //   else if(resultTitleTextWithoutSpaces == 'Turn_up_4_cm/_1_6_inches_'){
    //                   //       resultTitleTextWithoutSpaces = 'HemFinishing4CM'
    //                   //   }
    //                   //   Hem_finishing_value = resultTitleTextWithoutSpaces;
    //                   // }
    //                   // if (i == 5) {
    //                   //   if (resultTitleTextWithoutSpaces == '2_mm_(Standard)') {
    //                   //     resultTitleTextWithoutSpaces = 'AMF_2'
    //                   //   }
    //                   //   else if(resultTitleTextWithoutSpaces == '6_mm'){
    //                   //       resultTitleTextWithoutSpaces = 'AMF_6'
    //                   //   }
    //                   //   TAMF_Size = resultTitleTextWithoutSpaces
    //                   // }
    //                   // if (i == 6) {
    //                   //     pocket_side = resultTitleTextWithoutSpaces;
    //                   // }
    //                   // if (i == 7) {
    //                   //     if (resultTitleTextWithoutSpaces == 'Jetted') {
    //                   //       resultTitleTextWithoutSpaces = 'jetted_Button'
    //                   //     }
    //                   //     else if (resultTitleTextWithoutSpaces == 'Jetted_No_Button') {
    //                   //         resultTitleTextWithoutSpaces = 'jetted_no_Button'
    //                   //     }
    //                   //     else if (resultTitleTextWithoutSpaces == 'Jetted_No_Button') {
    //                   //       resultTitleTextWithoutSpaces = 'jetted_no_Button'
    //                   //     }
    //                   //     pockets_back = resultTitleTextWithoutSpaces;
    //                   // }
    //                 }
    //             update_Hem_finishing();
    //             update_Pleats();
    //             update_side_Pockets();
    //             update_Back_Pockets();
    //             update_Waistband();
    //             TupdateTuxedoColor()
    //             update_Coin_Pocket();
    //             }
    //       }
    //     else if(dataPageValue == 'custom-made-tuxedo-waistcoat') {
    //         // Iterate through each parent div for jacket model
    //         for (let i = 0; i < parentDivs.length; i++) {
    //             // Get the child div with the class "cm-modifier-card-wrapper"
    //             childDiv = parentDivs[i].querySelector('.cm-modifier-card-wrapper');
    //             // Check if the child div exists
    //             if (childDiv) {
    //                 // Access data or perform actions on the child div
    //                 // console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper

    //                 // Find the children div with class "cm-modifier-result-title" within childDiv
    //                 resultTitleDiv = childDiv.querySelector('.cm-modifier-result-title');

    //                 if (resultTitleDiv) {
    //                     resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
    //                     resultTitleTextWithoutSpaces = resultTitleText.replace(/[.\s:]+/g, '_'); // Replace spaces and dots with underscores
    //                     // console.log("Result Title: " + resultTitleTextWithoutSpaces); // Log the modified text content
    //                 }
    //                 if (i == 0) {

    //                   if (resultTitleTextWithoutSpaces == 'Single_Breasted_4_buttons') {
    //                       resultTitleTextWithoutSpaces = 'Single_Breasted_4_V_Shape'
    //                   }
    //                   else if (resultTitleTextWithoutSpaces == 'Single_Breasted_5_buttons') {
    //                     resultTitleTextWithoutSpaces = 'Single_Breasted_5_V_Shape'
    //                   }
    //                   else if (resultTitleTextWithoutSpaces == 'Single_Breasted_6_buttons') {
    //                     resultTitleTextWithoutSpaces = 'Single_Breasted_6_V_Shape'
    //                   }
    //                   else if (resultTitleTextWithoutSpaces == 'Double_Breasted_6_buttons') {
    //                     resultTitleTextWithoutSpaces = 'Double_Breasted_6_button_V'
    //                   }
    //                   twbuttoning = resultTitleTextWithoutSpaces
    //                 }
    //                 if (i == 1) {

    //                     if (resultTitleTextWithoutSpaces == 'V_shape') {
    //                       resultTitleTextWithoutSpaces = 'None'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Shawl_lapel') {
    //                       resultTitleTextWithoutSpaces = 'shawlLapel'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Notch_Lapel') {
    //                       resultTitleTextWithoutSpaces = 'Notch'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Peak_Lapel') {
    //                       resultTitleTextWithoutSpaces = 'Peak'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces = 'Horse_shoe') {
    //                       resultTitleTextWithoutSpaces = 'Horse'
    //                     }
    //                     twcollarStyle = resultTitleTextWithoutSpaces

    //                 }
    //                 if (i == 2) {
    //                     if (resultTitleTextWithoutSpaces == 'Single_Pocket') {
    //                       resultTitleTextWithoutSpaces = 'Single_pocket'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Dual_Pockets') {
    //                       resultTitleTextWithoutSpaces = 'Double_pocket'
    //                     }
    //                     twpocketsBack = resultTitleTextWithoutSpaces
    //                 }
    //                 if (i == 3) {
    //                     if (resultTitleTextWithoutSpaces == 'Straight_Pocket') {
    //                       resultTitleTextWithoutSpaces = 'Straight_pocket'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Jetted_Pocket') {
    //                        resultTitleTextWithoutSpaces = 'Jetted_pocket'
    //                     }
    //                     twpocketSide = resultTitleTextWithoutSpaces
    //                 }
    //                 if (i == 4) {
    //                     if (resultTitleTextWithoutSpaces == '2mm_(Standard)') {
    //                       resultTitleTextWithoutSpaces = 'AMF_2'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == '6mm') {
    //                       resultTitleTextWithoutSpaces = 'AMF_6'
    //                     }
    //                     amfSize = resultTitleTextWithoutSpaces
    //                 }
    //                 if (i == 5) {
    //                     twbackStyle = resultTitleTextWithoutSpaces
    //                 }
    //                 if (i == 6) {
    //                 }
    //                 if (i == 7) {
    //                     if (resultTitleTextWithoutSpaces == 'White') {
    //                        resultTitleTextWithoutSpaces = '#ffffff'
    //                      }
    //                     else if (resultTitleTextWithoutSpaces == 'Light_Grey') {
    //                       resultTitleTextWithoutSpaces = '#4d4d54';
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Dark_Grey') {
    //                       resultTitleTextWithoutSpaces = '#282024';
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Light_Blue') {
    //                       resultTitleTextWithoutSpaces = '#40546b';
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Pink') {
    //                       resultTitleTextWithoutSpaces = '#c72b52';
    //                     }
    //                     backColor = resultTitleTextWithoutSpaces
    //                 }
    //             }
    //             updateSidePockets();
    //             updateChestPockets();
    //             updateCollarStyles();
    //             updateBackColor(backColor)
    //         }
    //     }
    //     else if(dataPageValue == 'custom-made-tuxedo-suit') {
    //       if (jacketdiv.classList.contains("isSelected")) {
    //         for (let i = 0; i < 19; i++) {
    //           childDiv = parentDivs[i].querySelector('.cm-modifier-card-wrapper');
    //           if (childDiv) {
    //              console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper

    //             resultTitleDiv = childDiv.querySelector('.cm-modifier-result-title');
    //             if (resultTitleDiv) {
    //                     resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
    //                     resultTitleTextWithoutSpaces = resultTitleText.replace(/[.\s:]+/g, '_'); // Replace spaces and dots with underscores
    //                     // console.log("Result Title: " + resultTitleTextWithoutSpaces); // Log the modified text content
    //                 }
    //             if (i == 0) {
    //                 if (resultTitleTextWithoutSpaces == 'Single_Breasted_1_button') {
    //                     resultTitleTextWithoutSpaces = 'taxido-button-1';
    //                 }
    //               else if (resultTitleTextWithoutSpaces == 'Single_Breasted_2_button') {
    //                     resultTitleTextWithoutSpaces = 'taxido-button-2';
    //                 }
    //               else if (resultTitleTextWithoutSpaces == 'Double_Breasted_4_button') {
    //                     resultTitleTextWithoutSpaces = 'taxido-button-4';
    //                 }
    //               else if (resultTitleTextWithoutSpaces == 'Double_Breasted_6_button') {
    //                     resultTitleTextWithoutSpaces = 'taxido-button-6';
    //                 }
    //               else if (resultTitleTextWithoutSpaces == 'Double_Breasted_6_button_low') {
    //                     resultTitleTextWithoutSpaces = 'taxido-button-7';
    //                 }
    //                 let activediv = childDiv.querySelector('.cm-modifier-card-content');
    //                 if (activediv.classList.contains("active-option")) {
    //                     // // console.log(newresultTitleDiv);
    //                   loadLoader();
    //                   // console.log(resultTitleTextWithoutSpaces)
    //                   loadGLTFmoadl(resultTitleTextWithoutSpaces);
    //                   // scene.children.forEach(child => {
    //                   //     // Check if the child corresponds to any model from the loadedModels array
    //                   //     if (Object.values(loadedModels).includes(child)) {
    //                   //         // Remove the child from the scene
    //                   //         scene.remove(child);
    //                   //     }
    //                   // });

    //                   // // Add the new model to the scene if it exists in the loadedModels array
    //                   // if (loadedModels[resultTitleTextWithoutSpaces]) {
    //                   //     scene.add(loadedModels[resultTitleTextWithoutSpaces]);
    //                   // }
    //                 }
    //             }
    //             if (i == 1) {
    //                 if (resultTitleTextWithoutSpaces == 'Peak') {
    //                     resultTitleTextWithoutSpaces = 'peak';
    //                 }
    //               else if (resultTitleTextWithoutSpaces == 'Shawl') {
    //                     resultTitleTextWithoutSpaces = 'Shawl';
    //                 }
    //               Lapel_style_value = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 2) {
    //               if (resultTitleTextWithoutSpaces == 'Black_satin') {
    //                 resultTitleTextWithoutSpaces = 'black'
    //               } else if (resultTitleTextWithoutSpaces == 'Navy_satin') {
    //                 resultTitleTextWithoutSpaces = 'blue'
    //               } else if (resultTitleTextWithoutSpaces == 'White_satin') {
    //                 resultTitleTextWithoutSpaces = 'white'
    //               } else {
    //                 resultTitleTextWithoutSpaces = 'None'
    //               }
    //               sTuxedoColor = resultTitleTextWithoutSpaces
    //               console.log(sTuxedoColor)
    //               updateTuxedoColor()
    //             }
    //             if (i == 3) {
    //               if (resultTitleTextWithoutSpaces == 'Narrow') {
    //                     resultTitleTextWithoutSpaces = 'narrow';
    //                 }
    //                else if (resultTitleTextWithoutSpaces == 'Standard') {
    //                     resultTitleTextWithoutSpaces = 'standard';
    //                 }
    //               else if (resultTitleTextWithoutSpaces == 'Wide') {
    //                     resultTitleTextWithoutSpaces = 'wide';
    //                 }
    //                 Lapel_width  = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 4) {
    //               if (resultTitleTextWithoutSpaces == 'Double') {
    //                     resultTitleTextWithoutSpaces = 'double';
    //                 }
    //                else if (resultTitleTextWithoutSpaces == 'Single') {
    //                     resultTitleTextWithoutSpaces = 'single';
    //                 }
    //               else if (resultTitleTextWithoutSpaces == 'None') {
    //                     resultTitleTextWithoutSpaces = 'none';
    //                 }
    //                 Vent_value = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 4) {

    //             }
    //             if (i == 5) {

    //             }
    //             if (i == 6) {
    //                 if (resultTitleTextWithoutSpaces == 'Rope_Shoulder_-_Structured_(5_mm)') {
    //                   resultTitleTextWithoutSpaces = 'Rounded_Shoulder_5mm'
    //                 }
    //                 else if (resultTitleTextWithoutSpaces == 'Rope_Shoulder_-_Lightly_Padded_(2_mm)') {
    //                    resultTitleTextWithoutSpaces = 'Rounded_Shoulder_5mm'
    //                 }
    //                 else if (resultTitleTextWithoutSpaces == 'Natural_Shoulder_-_Structured_(5_mm)') {
    //                   resultTitleTextWithoutSpaces = 'Natural_Shoulder_5mm'
    //                 }
    //                 else if (resultTitleTextWithoutSpaces == 'Natural_Shoulder_-_Lightly_Padded_(2_mm)') {
    //                   resultTitleTextWithoutSpaces = 'Natural_Shoulder_2mm'
    //                 }
    //                 else if (resultTitleTextWithoutSpaces == 'Natural_Shoulder_-_Unconstructed_(0_mm)') {
    //                   resultTitleTextWithoutSpaces = 'Natural_Shoulder_0mm'
    //                 }
    //                 else if (resultTitleTextWithoutSpaces == 'La_Spalla_Camicia_-_Unconstrcuted_(2_mm)') {
    //                     resultTitleTextWithoutSpaces = 'spalla_camicia_2mm'
    //                 }
    //                 else if (resultTitleTextWithoutSpaces == 'La_Spalla_Camicia_-_Unconstrcuted_(0_mm)') {
    //                     resultTitleTextWithoutSpaces = 'spalla_camicia_0mm'
    //                 }
    //                 Shoulder = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 7) {
    //                 if (resultTitleTextWithoutSpaces == '2_mm_(Standard)') {
    //                   resultTitleTextWithoutSpaces = 'mm2'
    //                 } else if (resultTitleTextWithoutSpaces == '6_mm') {
    //                     resultTitleTextWithoutSpaces = 'mm6'
    //                 }
    //                 AMF_Size = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 8) {
    //                 if (resultTitleTextWithoutSpaces == 'Boat') {
    //                   resultTitleTextWithoutSpaces = 'Boat_Shape'
    //                 } else if (resultTitleTextWithoutSpaces == 'Patch') {
    //                     resultTitleTextWithoutSpaces = 'patch'
    //                 } else if (resultTitleTextWithoutSpaces == 'Rounded_patch') {
    //                     resultTitleTextWithoutSpaces = 'Rounded'
    //                 } else if (resultTitleTextWithoutSpaces == 'Pleat_patch') {
    //                     resultTitleTextWithoutSpaces = 'pleat_B'
    //                 }
    //                 Chest_Pocket_value = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 9) {
    //               if (resultTitleTextWithoutSpaces == 'Slanted_Flap') {
    //                   resultTitleTextWithoutSpaces = 'Slanted_Flap001'
    //               } else if (resultTitleTextWithoutSpaces == 'Jetted') {
    //                   resultTitleTextWithoutSpaces = 'Jetted001'
    //               } else if (resultTitleTextWithoutSpaces == 'Slanted_Jetted') {
    //                   resultTitleTextWithoutSpaces = 'Slanted_Jetted001'
    //               }
    //               side_pocket_value = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 10) {
    //               if (resultTitleTextWithoutSpaces == 'Yes') {
    //                   Ticket_pocket_value = true;
    //               } else {
    //                   Ticket_pocket_value = false;
    //               }
    //             }
    //             if (i == 12) {
    //               if (resultTitleTextWithoutSpaces == 'Yes') {
    //                 Cuffed_sleeve_value = true;
    //               }
    //               else {
    //                 Cuffed_sleeve_value = false;
    //               }
    //             }
    //             if (i == 13) {
    //               if (resultTitleTextWithoutSpaces == '3_kissing') {
    //                   resultTitleTextWithoutSpaces = 'kissing_3'
    //               } else if (resultTitleTextWithoutSpaces == '3_non-kissing') {
    //                   resultTitleTextWithoutSpaces = 'non_kissing_3'
    //               } else if (resultTitleTextWithoutSpaces == '4_kissing_(Standard)') {
    //                   resultTitleTextWithoutSpaces = 'kissing_4'
    //               } else if (resultTitleTextWithoutSpaces == '4_non-kissing') {
    //                   resultTitleTextWithoutSpaces = 'non_kissing_4'
    //               } else if (resultTitleTextWithoutSpaces == '5_kissing_special_(Tom_Ford)') {
    //                   resultTitleTextWithoutSpaces = 'kissing_5'
    //               } else if (resultTitleTextWithoutSpaces == '5_non-kissing') {
    //                   resultTitleTextWithoutSpaces = 'non_kissing_5'
    //               } else if (resultTitleTextWithoutSpaces == '1_sleeve_button') {
    //                   resultTitleTextWithoutSpaces = 'sleeve_button_1'
    //               }
    //               Sleeve_Button_value = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 14) {
    //                 if (resultTitleTextWithoutSpaces == 'Left_(Standard)') {
    //                     resultTitleTextWithoutSpaces = 'right'
    //                 } else if (resultTitleTextWithoutSpaces == 'Right') {
    //                     resultTitleTextWithoutSpaces = 'left'
    //                 }
    //                 hole_Position = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 15) {
    //               if (resultTitleTextWithoutSpaces == 'Traditional') {
    //                 resultTitleTextWithoutSpaces = 'Handmade'
    //               }
    //               else if (resultTitleTextWithoutSpaces == 'Handmade_milanese') {
    //                 resultTitleTextWithoutSpaces = 'Traditional'
    //               }
    //               Lapel_buttonhole = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 16) {
    //                if (resultTitleTextWithoutSpaces == 'Half_Lined') {
    //                   resultTitleTextWithoutSpaces = 'halfline'
    //               } else if (resultTitleTextWithoutSpaces == 'Fully_Lined') {
    //                   resultTitleTextWithoutSpaces = 'full'
    //               }
    //               Lining_value = resultTitleTextWithoutSpaces
    //             }
    //             if (i == 16) {

    //             }
    //             update_Lapel_width();
    //             update_Shoulders();
    //             update_Side_Pocket();
    //             update_Ticket_pockets();
    //             update_Vent();
    //             update_Lining();
    //             update_Sleeve_Button();
    //             update_Chest_Pocket();
    //             console.log(sTuxedoColor)
    //             // updateTuxedoColor();
    //             update_Cuffed_sleeve(Cuffed_sleeve_value)
    //           }
    //         }
    //       }
    //       else if (trouserdiv.classList.contains("isSelected")) {
    //         for (let i = 20; i < 34; i++) {
    //            // Get the child div with the class "cm-modifier-card-wrapper"
    //                 childDiv = parentDivs[i].querySelector('.cm-modifier-card-wrapper');
    //                 // Check if the child div exists
    //                 if (childDiv) {
    //                     // Access data or perform actions on the child div
    //                     // console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper

    //                     // Find the children div with class "cm-modifier-result-title" within childDiv
    //                     resultTitleDiv = childDiv.querySelector('.cm-modifier-result-title');

    //                     if (resultTitleDiv) {
    //                         resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
    //                         resultTitleTextWithoutSpaces = resultTitleText.replace(/[.\s:]+/g, '_'); // Replace spaces and dots with underscores
    //                         // console.log("Result Title: " + resultTitleTextWithoutSpaces); // Log the modified text content
    //                     }
    //                     if (i == 20) {
    //                       if (resultTitleTextWithoutSpaces == 'Oscar_Straight_[7_cm_overlap]') {
    //                         resultTitleTextWithoutSpaces = 'Oscar_Straight'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Oscar_Straight_Extended_[11_cm_overlap]') {
    //                         resultTitleTextWithoutSpaces = 'Oscar_Straight_Extended'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Oscar_Straight_Extended_[11_cm_overlap]') {
    //                         resultTitleTextWithoutSpaces = 'Oscar_Straight_Extended'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Oscar_Peak_[7_cm_overlap]') {
    //                         resultTitleTextWithoutSpaces = 'Oscar_Peak'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Oscar_Peak_Extended_[11_cm_overlap]') {
    //                         resultTitleTextWithoutSpaces = 'Oscar_Peak_Extended'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Drawstring') {
    //                         resultTitleTextWithoutSpaces = 'DrawString'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Original_Gurkha') {
    //                         resultTitleTextWithoutSpaces = 'Gurkha_double'
    //                       }
    //                       waistband_value = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 21) {
    //                       if (resultTitleTextWithoutSpaces == 'None') {
    //                           resultTitleTextWithoutSpaces = 'None'
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Belt_Loop') {
    //                           resultTitleTextWithoutSpaces = 'Belt';
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Side-adjusters') {
    //                           resultTitleTextWithoutSpaces = 'Side_adjusters_';
    //                       }
    //                       else if (resultTitleTextWithoutSpaces == 'Lowered_Side-adjusters') {
    //                           resultTitleTextWithoutSpaces = 'Lower_Side_adjusters';
    //                       }
    //                       fasteting_value = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 22) {
    //                       if (resultTitleTextWithoutSpaces == '3_5_cm') {
    //                         resultTitleTextWithoutSpaces = '0'
    //                       } else if (resultTitleTextWithoutSpaces == '4_cm') {
    //                         resultTitleTextWithoutSpaces = '1'
    //                       } else if (resultTitleTextWithoutSpaces == '5_cm') {
    //                         resultTitleTextWithoutSpaces = '2'
    //                       }
    //                       waistband_height = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 23) {
    //                     if (resultTitleTextWithoutSpaces == 'Yes') {
    //                         coin_pocket_value = true;
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'No') {
    //                         coin_pocket_value = false;
    //                     }
    //                   }
    //                   if (i == 24) {

    //                   }
    //                   if (i == 25) {
    //                      if (resultTitleTextWithoutSpaces == 'No_pleats') {
    //                       resultTitleTextWithoutSpaces = 'Normal_straight_pant'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Outward_Single_Pleats'){
    //                         resultTitleTextWithoutSpaces = 'Standardsinglee'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Outward_Double_Pleats'){
    //                         resultTitleTextWithoutSpaces = 'StandardDouble'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Inward_Single_Pleats'){
    //                         resultTitleTextWithoutSpaces = 'INWARDSINGLE'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Inward_Double_Pleats'){
    //                         resultTitleTextWithoutSpaces = 'INWARDDouble'
    //                     }
    //                     Pleat = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 26) {
    //                     if (resultTitleTextWithoutSpaces == 'Plain') {
    //                       resultTitleTextWithoutSpaces = 'None'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Turn_up_6_cm/_XX_inches_'){
    //                         resultTitleTextWithoutSpaces = 'HemFinishing6CM'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Turn_up_5_cm_/_XX_inches_(Standard)'){
    //                         resultTitleTextWithoutSpaces = 'HemFinishing5CM'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == 'Turn_up_4_cm/_XX_inches_'){
    //                         resultTitleTextWithoutSpaces = 'HemFinishing4CM'
    //                     }
    //                     Hem_finishing_value = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 27) {
    //                     if (resultTitleTextWithoutSpaces == '2_mm_(Standard)') {
    //                       resultTitleTextWithoutSpaces = 'AMF_2'
    //                     }
    //                     else if(resultTitleTextWithoutSpaces == '6_mm'){
    //                         resultTitleTextWithoutSpaces = 'AMF_6'
    //                     }
    //                     TAMF_Size = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 28) {
    //                     pocket_side = resultTitleTextWithoutSpaces
    //                   }
    //                   if (i == 29) {
    //                     if (resultTitleTextWithoutSpaces == 'Black_satin') {
    //                       resultTitleTextWithoutSpaces = '#000000'
    //                     } else if (resultTitleTextWithoutSpaces == 'Navy_satin') {
    //                       resultTitleTextWithoutSpaces = '#34394a'
    //                     } else if (resultTitleTextWithoutSpaces == 'White_satin') {
    //                       resultTitleTextWithoutSpaces = '#a8a8a8'
    //                     } else {
    //                       resultTitleTextWithoutSpaces = 'None'
    //                     }
    //                     colorTuxedo = resultTitleTextWithoutSpaces
    //                     console.log(sTuxedoColor)
    //                   }
    //                   if (i == 30) {
    //                     if (resultTitleTextWithoutSpaces == 'Jetted') {
    //                       resultTitleTextWithoutSpaces = 'jetted_Button'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Jetted_No_Button') {
    //                         resultTitleTextWithoutSpaces = 'jetted_no_Button'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Jetted_No_Button') {
    //                       resultTitleTextWithoutSpaces = 'jetted_no_Button'
    //                     }
    //                     pockets_back = resultTitleTextWithoutSpaces;
    //                   }
    //                   if (i == 31) {

    //                   }
    //                 }
    //             update_Hem_finishing();
    //             update_Pleats();
    //             update_side_Pockets();
    //             update_Back_Pockets();
    //             update_Waistband();
    //             TupdateTuxedoColor()
    //             update_Coin_Pocket()
    //         }
    //       }
    //       else if (waistecoatdiv.classList.contains("isSelected")) {
    //         for (let i = 35; i < 43; i++) {
    //           // Get the child div with the class "cm-modifier-card-wrapper"
    //             childDiv = parentDivs[i].querySelector('.cm-modifier-card-wrapper');
    //             // Check if the child div exists
    //             if (childDiv) {
    //                 // Access data or perform actions on the child div
    //                 // console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper

    //                 // Find the children div with class "cm-modifier-result-title" within childDiv
    //                 resultTitleDiv = childDiv.querySelector('.cm-modifier-result-title');

    //                 if (resultTitleDiv) {
    //                     resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
    //                     resultTitleTextWithoutSpaces = resultTitleText.replace(/[.\s:]+/g, '_'); // Replace spaces and dots with underscores
    //                     // console.log("Result Title: " + resultTitleTextWithoutSpaces); // Log the modified text content
    //                 }
    //                 if (i == 36) {

    //                   if (resultTitleTextWithoutSpaces == 'Single_Breasted_4_buttons') {
    //                       resultTitleTextWithoutSpaces = 'Single_Breasted_4_V_Shape'
    //                   }
    //                   else if (resultTitleTextWithoutSpaces == 'Single_Breasted_5_buttons') {
    //                     resultTitleTextWithoutSpaces = 'Single_Breasted_5_V_Shape'
    //                   }
    //                   else if (resultTitleTextWithoutSpaces == 'Single_Breasted_6_buttons') {
    //                     resultTitleTextWithoutSpaces = 'Single_Breasted_6_V_Shape'
    //                   }
    //                   else if (resultTitleTextWithoutSpaces == 'Double_Breasted_6_buttons') {
    //                     resultTitleTextWithoutSpaces = 'Double_Breasted_6_button_V'
    //                   }
    //                   twbuttoning = resultTitleTextWithoutSpaces
    //                 }
    //                 if (i == 37) {

    //                     if (resultTitleTextWithoutSpaces == 'V_shape') {
    //                       resultTitleTextWithoutSpaces = 'None'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Shawl_lapel') {
    //                       resultTitleTextWithoutSpaces = 'shawlLapel'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Notch_Lapel') {
    //                       resultTitleTextWithoutSpaces = 'Notch'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Peak_Lapel') {
    //                       resultTitleTextWithoutSpaces = 'Peak'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces = 'Horse_shoe') {
    //                       resultTitleTextWithoutSpaces = 'Horse'
    //                     }
    //                     twcollarStyle = resultTitleTextWithoutSpaces

    //                 }
    //                 if (i == 38) {
    //                     if (resultTitleTextWithoutSpaces == 'Single_Pocket') {
    //                       resultTitleTextWithoutSpaces = 'Single_pocket'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Dual_Pockets') {
    //                       resultTitleTextWithoutSpaces = 'Double_pocket'
    //                     }
    //                     twpocketsBack = resultTitleTextWithoutSpaces
    //                 }
    //                 if (i == 39) {
    //                     if (resultTitleTextWithoutSpaces == 'Straight_Pocket') {
    //                       resultTitleTextWithoutSpaces = 'Straight_pocket'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Jetted_Pocket') {
    //                        resultTitleTextWithoutSpaces = 'Jetted_pocket'
    //                     }
    //                     twpocketSide = resultTitleTextWithoutSpaces
    //                 }
    //                 if (i == 40) {
    //                     if (resultTitleTextWithoutSpaces == '2mm_(Standard)') {
    //                       resultTitleTextWithoutSpaces = 'AMF_2'
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == '6mm') {
    //                       resultTitleTextWithoutSpaces = 'AMF_6'
    //                     }
    //                     amfSize = resultTitleTextWithoutSpaces
    //                 }
    //                 if (i == 41) {
    //                     twbackStyle = resultTitleTextWithoutSpaces
    //                 }
    //                 if (i == 42) {
    //                 }
    //                 if (i == 43) {
    //                     if (resultTitleTextWithoutSpaces == 'White') {
    //                        resultTitleTextWithoutSpaces = '#ffffff'
    //                      }
    //                     else if (resultTitleTextWithoutSpaces == 'Light_Grey') {
    //                       resultTitleTextWithoutSpaces = '#4d4d54';
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Dark_Grey') {
    //                       resultTitleTextWithoutSpaces = '#282024';
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Light_Blue') {
    //                       resultTitleTextWithoutSpaces = '#40546b';
    //                     }
    //                     else if (resultTitleTextWithoutSpaces == 'Pink') {
    //                       resultTitleTextWithoutSpaces = '#c72b52';
    //                     }
    //                     backColor = resultTitleTextWithoutSpaces
    //                 }
    //             }
    //             updateSidePockets();
    //             updateChestPockets();
    //             updateCollarStyles();
    //             updateBackColor(backColor)
    //         }
    //       }
    //     }
    // }, 500);
  }
);

function modelvales(obj) {
  setTimeout(() => {
    // Get all the parent divs with the class "cm-modifier-card-container"
    let parentDivs = document.querySelectorAll(".cm-modifier-card-container");
    let resultTitleText, resultTitleTextWithoutSpaces, childDiv, resultTitleDiv,filter_label,filter_label_value;

    if (dataPageValue == "custom-made-tuxedo-jacket") {
      // Iterate through each parent div for Trouser model
      for (let i = 0; i < parentDivs.length; i++) {
        // Get the child div with the class "cm-modifier-card-wrapper"
        childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
        // Check if the child div exists
        if (childDiv) {
          filter_label = childDiv.querySelector(".cm-modifier-col-title");
          // Access data or perform actions on the child div
          // Find the children div with class "cm-modifier-result-title" within childDiv
          resultTitleDiv = childDiv.querySelector(".cm-modifier-result-title");

          if (resultTitleDiv) {
            resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
            filter_label_value = filter_label.textContent.trim();
            resultTitleTextWithoutSpaces = resultTitleText.replace(
              /[.\s:]+/g,
              "_"
            ); // Replace spaces and dots with underscores
            filter_label_value = filter_label_value.replace(
              /[.\s:]+/g,
              "_"
            );
          }

          if (filter_label_value == "Buttoning") {

            if (resultTitleTextWithoutSpaces == "Single_Breasted_1_button") {
              resultTitleTextWithoutSpaces = "taxido-button-1";
            } else if (
              resultTitleTextWithoutSpaces == "Single_Breasted_2_button"
            ) {
              resultTitleTextWithoutSpaces = "taxido-button-2";
            } else if (
              resultTitleTextWithoutSpaces == "Double_Breasted_4_button"
            ) {
              resultTitleTextWithoutSpaces = "taxido-button-4";
            } else if (
              resultTitleTextWithoutSpaces == "Double_Breasted_6_button"
            ) {
              resultTitleTextWithoutSpaces = "taxido-button-6";
            } else if (
              resultTitleTextWithoutSpaces == "Double_Breasted_6_button_low"
            ) {
              resultTitleTextWithoutSpaces = "taxido-button-7";
            }else if (
              resultTitleTextWithoutSpaces == "Double_Breasted_4_button_low"
            ) {
              resultTitleTextWithoutSpaces = "tuxido-button-4-low";
            }
            let activediv = childDiv.querySelector(".cm-modifier-card-content");
            if (activediv.classList.contains("active-option")) {
              loadLoader();
              loadGLTFmoadl(resultTitleTextWithoutSpaces);
            }
          }

          if (filter_label_value == 'Vent') {
           resultTitleDiv = resultTitleDiv.textContent.trim().toLowerCase();
           // sLapelstyle = resultTitleDiv
           Vent_value = resultTitleDiv;
          }

          if (filter_label_value == "Lapel_style") {
            if (resultTitleTextWithoutSpaces == "Peak") {
              resultTitleTextWithoutSpaces = "peak";
            } else if (resultTitleTextWithoutSpaces == "Shawl") {
              resultTitleTextWithoutSpaces = "Shawl";
            }
            Lapel_style_value = resultTitleTextWithoutSpaces;
          }
          if (filter_label_value == "Lapel_width") {

            if (resultTitleTextWithoutSpaces == "Narrow") {
              resultTitleTextWithoutSpaces = "narrow";
            } else if (resultTitleTextWithoutSpaces == "Mid") {
              resultTitleTextWithoutSpaces = "standard";
            } else if (resultTitleTextWithoutSpaces == "Wide_(Standard)") {
              resultTitleTextWithoutSpaces = "wide";
            }
            Lapel_width = resultTitleTextWithoutSpaces;
          }

          if (filter_label_value == "Lapel_material") { 
            if (resultTitleTextWithoutSpaces == "Black_satin") {
              sColorType = "satin"
              resultTitleTextWithoutSpaces = "black";
            } else if (resultTitleTextWithoutSpaces == "Navy_satin") {
              sColorType = "satin"
              resultTitleTextWithoutSpaces = "blue";
            } else if (resultTitleTextWithoutSpaces == "White_satin") {
              sColorType = "satin"
              resultTitleTextWithoutSpaces = "white";
            } else if (resultTitleTextWithoutSpaces == "Black_grosgrain") {
              sColorType = "grosgrain"
              resultTitleTextWithoutSpaces = "black";
            } else if (resultTitleTextWithoutSpaces == "Navy_grosgrain") {
              sColorType = "grosgrain"
              resultTitleTextWithoutSpaces = "blue";
            } else if (resultTitleTextWithoutSpaces == "White_grosgrain") {
              sColorType = "grosgrain"
              resultTitleTextWithoutSpaces = "white";
            } else {
              resultTitleTextWithoutSpaces = "None";
            }
            sTuxedoColor = resultTitleTextWithoutSpaces;
            updateTuxedoColor();
          }
          if (filter_label_value == "Shoulder") {

            console.log("Shoulder::",resultTitleTextWithoutSpaces)
            if (
            resultTitleTextWithoutSpaces ==
              "Rope_Shoulder_-_Structured_(5_mm)"
            ) {
              resultTitleTextWithoutSpaces = "Rounded_Shoulder_5mm";
            } else if (
              resultTitleTextWithoutSpaces ==
              "Rope_Shoulder_-_Lightly_Padded_(2_mm)"
            ) {
              resultTitleTextWithoutSpaces = "Rounded_Shoulder_2mm";
            } else if (
              resultTitleTextWithoutSpaces ==
              "Natural_Shoulder_-_Structured_(5_mm)"
            ) {
              resultTitleTextWithoutSpaces = "Natural_Shoulder_5mm";
            } else if (
              resultTitleTextWithoutSpaces ==
              "Natural_Shoulder_-_Lightly_Padded_(2_mm)"
            ) {
              resultTitleTextWithoutSpaces = "Natural_Shoulder_2mm";
            } else if (
              resultTitleTextWithoutSpaces ==
              "Natural_Shoulder_-_Unconstructed_(0_mm)"
            ) {
              resultTitleTextWithoutSpaces = "Natural_Shoulder_0mm";
            } else if (
                resultTitleTextWithoutSpaces ==
                "La_Spalla_Camicia_-_Lightly_Padded_(2_mm)"
            ) {
                resultTitleTextWithoutSpaces = "spalla_camicia_2mm";
            } else if (
                resultTitleTextWithoutSpaces ==
                "La_Spalla_Camicia_-_Unconstructed_(0_mm)"
            ) {
                resultTitleTextWithoutSpaces = "spalla_camicia_0mm";
            }
            Shoulder = resultTitleTextWithoutSpaces;
          }

          if (filter_label_value ==  "Chest_pocket") {
            if (resultTitleTextWithoutSpaces == "Boat") {
              resultTitleTextWithoutSpaces = "Boat_Shape";
            } else if (resultTitleTextWithoutSpaces == "Patch") {
              resultTitleTextWithoutSpaces = "patch";
            } else if (resultTitleTextWithoutSpaces == "Rounded_patch") {
              resultTitleTextWithoutSpaces = "Rounded";
            } else if (resultTitleTextWithoutSpaces == "Pleat_patch") {
              resultTitleTextWithoutSpaces = "pleat_B";
            }
            Chest_Pocket_value = resultTitleTextWithoutSpaces;

          }

          if (filter_label_value == "Side_pockets") {

            if (resultTitleTextWithoutSpaces == "Slanted_flap") {
              resultTitleTextWithoutSpaces = "Slanted_Flap001";
            } else if (resultTitleTextWithoutSpaces == "Jetted") {
              resultTitleTextWithoutSpaces = "Jetted001";
            } else if (resultTitleTextWithoutSpaces == "Slanted_jetted") {
              resultTitleTextWithoutSpaces = "Slanted_Jetted001";
            }
            side_pocket_value = resultTitleTextWithoutSpaces;
          }

          if (filter_label_value  == "Ticket_pocket") {

            if (resultTitleTextWithoutSpaces == "Yes") {
              Ticket_pocket_value = true;
            } else {
              Ticket_pocket_value = false;
            }
          }

          if (filter_label_value == "Buttons") {
            sButtons_texture = resultTitleTextWithoutSpaces;
            updateButtonImage(buttons.children[3].children[1].material);
          }

          if (filter_label_value  == "Lining") {

            if (resultTitleTextWithoutSpaces == "Half_Lined") {
              resultTitleTextWithoutSpaces = "halfline";
            } else if (resultTitleTextWithoutSpaces == "Fully_Lined") {
              resultTitleTextWithoutSpaces = "full";
            }
            Lining_value = resultTitleTextWithoutSpaces;
          }

          if (filter_label_value == 'Cuffed_sleeve') {
            if (resultTitleTextWithoutSpaces == "Yes") {
                Cuffed_sleeve_value = true;
            } else {
                Cuffed_sleeve_value = false;
            }
          }
                    
          if (filter_label_value == 'Sleeve_buttons') {
            if (resultTitleTextWithoutSpaces == "1_sleeve_button") {
                resultTitleTextWithoutSpaces = "sleeve_button_1";
            } else if (resultTitleTextWithoutSpaces == "3_kissing") {
                resultTitleTextWithoutSpaces = "kissing_3";
            } else if (resultTitleTextWithoutSpaces == "3_non-kissing") {
                resultTitleTextWithoutSpaces = "non_kissing_3";
            } else if (resultTitleTextWithoutSpaces == "4_kissing") {
                resultTitleTextWithoutSpaces = "kissing_4";
            } else if (resultTitleTextWithoutSpaces == "4_non-kissing") {
                resultTitleTextWithoutSpaces = "non_kissing_4";
            } else if (
                resultTitleTextWithoutSpaces == "5_kissing"
            ) {
                resultTitleTextWithoutSpaces = "kissing_5";
            } else if (resultTitleTextWithoutSpaces == "5_non-kissing") {
                resultTitleTextWithoutSpaces = "non_kissing_5";
            }
            Sleeve_Button_value = resultTitleTextWithoutSpaces;
          }
                    
                    
          if (filter_label_value == 'Buttonhole_lapel') {
              if (resultTitleTextWithoutSpaces == "Traditional") {
                  resultTitleTextWithoutSpaces = "Handmade";
              } else if (resultTitleTextWithoutSpaces == "milanese") {
                  resultTitleTextWithoutSpaces = "Traditional";
              }else if (resultTitleTextWithoutSpaces == "Milanese") {
                  resultTitleTextWithoutSpaces = "Traditional";
              }
              console.log("button-hole::",resultTitleTextWithoutSpaces)
              Lapel_buttonhole = resultTitleTextWithoutSpaces;
          }
          
          if (filter_label_value == 'Buttonhole_lapel_position') {
              if (resultTitleTextWithoutSpaces == "Left_(Standard)") {
                  resultTitleTextWithoutSpaces = "right";
              } else if (resultTitleTextWithoutSpaces == "Right") {
                  resultTitleTextWithoutSpaces = "left";
              }
              hole_Position = resultTitleTextWithoutSpaces;
          }
  
          if (filter_label_value == 'AMF') {
              if (resultTitleTextWithoutSpaces == "2_mm_(Standard)") {
                  resultTitleTextWithoutSpaces = "mm2";
              } else if (resultTitleTextWithoutSpaces == "6_mm") {
                  resultTitleTextWithoutSpaces = "mm6";
              }
              AMF_Size = resultTitleTextWithoutSpaces;
          }

          if (filter_label_value  == "Lining_colour") {
            sLiningColor = getLiningColor(resultTitleTextWithoutSpaces);
            update_lining_color();
          }

          update_Lapel_width(
            Lapel_style_value,
            Lapel_width,
            Lapel_buttonhole,
            AMF_Size,
            hole_Position
          );
          update_Chest_Pocket(Chest_Pocket_value);
          update_Side_Pocket(side_pocket_value);
          update_Ticket_pockets(side_pocket_value);
          update_Lining(Lining_value);
          update_Sleeve_Button(Sleeve_Button_value, Chest_Pocket_value, side_pocket_value);
          update_Shoulders(Shoulder);
          update_Vent(Vent_value, AMF_Size, Shoulder);
          update_Cuffed_sleeve(Cuffed_sleeve_value);
        }
      }
    }
    else if (dataPageValue == "custom-made-tuxedo-trouser") {

      // Iterate through each parent div for Waistcoat model
      for (let i = 0; i < parentDivs.length; i++) {
        // Get the child div with the class "cm-modifier-card-wrapper"
        childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
        // Check if the child div exists
        if (childDiv) {
          // Access data or perform actions on the child div

          filter_label = childDiv.querySelector(".cm-modifier-col-title");
          // Find the children div with class "cm-modifier-result-title" within childDiv
          resultTitleDiv = childDiv.querySelector(".cm-modifier-result-title");

          if (resultTitleDiv) {
            resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
            filter_label_value = filter_label.textContent.trim();
            resultTitleTextWithoutSpaces = resultTitleText.replace(
              /[.\s:]+/g,
              "_"
            ); // Replace spaces and dots with underscores   
            
            filter_label_value = filter_label_value.replace(
              /[.\s:]+/g,
              "_"
            );
          }

          if (filter_label_value == "Waistband") {

            if (
              resultTitleTextWithoutSpaces == "Straight"
            ) {
              resultTitleTextWithoutSpaces = "Oscar_Straight";
            } else if (
              resultTitleTextWithoutSpaces ==
              "Straight_Extended"
            ) {
              resultTitleTextWithoutSpaces = "Oscar_Straight_Extended";
            } else if (
              resultTitleTextWithoutSpaces == "Peak"
            ) {
              resultTitleTextWithoutSpaces = "Oscar_Peak";
            } else if (resultTitleTextWithoutSpaces == "Peak_Extended") 
            {
              resultTitleTextWithoutSpaces = "Oscar_Peak_Extended";
            } else if (resultTitleTextWithoutSpaces == "Drawstring") {
              resultTitleTextWithoutSpaces = "DrawString";
            } else if (resultTitleTextWithoutSpaces == "Original_Gurkha") {
              resultTitleTextWithoutSpaces = "Gurkha_double";
            }

            waistband_value = resultTitleTextWithoutSpaces;
          }
          if (filter_label_value == "Waistband_height") {
            if (resultTitleTextWithoutSpaces == "Low_(3_5_cm_/_1_4_in)") {
              resultTitleTextWithoutSpaces = "0";
            } else if (resultTitleTextWithoutSpaces == "Mid_(4_cm_/_1_6_in)") {
              resultTitleTextWithoutSpaces = "1";
            } else if (resultTitleTextWithoutSpaces == "High_(5_cm_/_2_0_in)") {
              resultTitleTextWithoutSpaces = "2";
            }
            
            if(childDiv.closest(".cm-modifier-card-container").style.display != 'none'){
              waistband_height = resultTitleTextWithoutSpaces;
            }else{
              waistband_height = 0;
            }
          }
          if (filter_label_value =="Fastening") {

            console.log("Fastening ::",resultTitleTextWithoutSpaces)
            if (resultTitleTextWithoutSpaces == "No_fastening") {
              resultTitleTextWithoutSpaces = "None";
            } else if (resultTitleTextWithoutSpaces == "Belt_loops") {
              resultTitleTextWithoutSpaces = "Belt";
            } else if (resultTitleTextWithoutSpaces == "Side_adjusters") {
              resultTitleTextWithoutSpaces = "Side_adjusters_";
            } else if (
              resultTitleTextWithoutSpaces == "Lowered_Side_adjusters"
            ) {
              resultTitleTextWithoutSpaces = "Lower_Side_adjusters";
            }


            
            if(childDiv.closest(".cm-modifier-card-container").style.display != 'none'){
              fasteting_value = resultTitleTextWithoutSpaces;
            }else{
              fasteting_value = "None";
            }
          }
          if (filter_label_value =="Pleats") {
            if (resultTitleTextWithoutSpaces == "No_pleats") {
              resultTitleTextWithoutSpaces = "Normal_straight_pant";
            } else if (
              resultTitleTextWithoutSpaces == "Single_Pleats_(Outward)"
            ) {
              resultTitleTextWithoutSpaces = "Standardsinglee";
            } else if (
              resultTitleTextWithoutSpaces == "Double_Pleats_(Outward)"
            ) {
              resultTitleTextWithoutSpaces = "StandardDouble";
            } else if (resultTitleTextWithoutSpaces == "Single_Pleats_(Inward)") {
              resultTitleTextWithoutSpaces = "INWARDSINGLE";
            } else if (resultTitleTextWithoutSpaces == "Double_Pleats_(Inward)") {
              resultTitleTextWithoutSpaces = "INWARDDouble";
            }
            Pleat = resultTitleTextWithoutSpaces;
          }

          if (filter_label_value =="Side_Stripe_Fabric") {
            // if (resultTitleTextWithoutSpaces == "Black_satin") {
            //   resultTitleTextWithoutSpaces = "#000000";
            // } else if (resultTitleTextWithoutSpaces == "Navy_satin") {
            //   resultTitleTextWithoutSpaces = "#34394a";
            // } else if (resultTitleTextWithoutSpaces == "White_satin") {
            //   resultTitleTextWithoutSpaces = "#a8a8a8";
            // } else 
            
            if (resultTitleTextWithoutSpaces == "Fabric_only") {
              resultTitleTextWithoutSpaces = "None";
              colorTuxedo = resultTitleTextWithoutSpaces
            }else{
              colorTuxedo = getLiningColor(resultTitleTextWithoutSpaces);
            }
          }

          if (filter_label_value =="Hem_finishing") {

            console.log("Hem_finishing",resultTitleTextWithoutSpaces)

            if (resultTitleTextWithoutSpaces == "Plain") {
              resultTitleTextWithoutSpaces = "None";
            } else if (
              resultTitleTextWithoutSpaces == "Cuffed_hem_(6_cm_/_2_4_in)"
            ) {
              resultTitleTextWithoutSpaces = "HemFinishing6CM";
            } else if (
              resultTitleTextWithoutSpaces ==
              "Cuffed_hem_(5_cm_/_2_in)"
            ) {
              resultTitleTextWithoutSpaces = "HemFinishing5CM";
            } else if (
              resultTitleTextWithoutSpaces == "Cuffed_hem_(4_cm_/_1_6_in)"
            ) {
              resultTitleTextWithoutSpaces = "HemFinishing4CM";
            }
            Hem_finishing_value = resultTitleTextWithoutSpaces;
          }

          if (filter_label_value =="Buttons") {
            sButtons_texture = resultTitleTextWithoutSpaces;
            updateButtonImage(coin_Pocket.children[0].children[0].material);
          }

          if (filter_label_value =="Side_pockets") {
            pocket_side = resultTitleTextWithoutSpaces;
          }

          if (filter_label_value == 'Back_pockets') {
            if (resultTitleTextWithoutSpaces == "Jetted_with_button") {
                resultTitleTextWithoutSpaces = "jetted_Button";
            } else if (resultTitleTextWithoutSpaces == "Jetted_without_button") {
                resultTitleTextWithoutSpaces = "jetted_no_Button";
            } else if (resultTitleTextWithoutSpaces == "Jetted_No_Button") {
                resultTitleTextWithoutSpaces = "jetted_no_Button";
            }
            pockets_back = resultTitleTextWithoutSpaces;
          }

          if (filter_label_value == 'Coin_pocket') {
            if (resultTitleTextWithoutSpaces == "Yes") {
                coin_pocket_value = true;
            } else if (resultTitleTextWithoutSpaces == "No") {
                coin_pocket_value = false;
            }
          }

          if (filter_label_value == 'AMF_Stiching') {
            if (resultTitleTextWithoutSpaces == "2_mm") {
            resultTitleTextWithoutSpaces = "AMF_2";
            } else if (resultTitleTextWithoutSpaces == "6_mm") {
                resultTitleTextWithoutSpaces = "AMF_6";
            }
            TAMF_Size = resultTitleTextWithoutSpaces;
          }

        }

        update_Fasteting(fasteting_value, waistband_value, waistband_height);
        update_Hem_finishing(Hem_finishing_value);
        update_Pleats(Pleat);
        update_side_Pockets(pocket_side, TAMF_Size);
        update_Back_Pockets(pockets_back);
        update_Waistband(waistband_value, waistband_height);
        TupdateTuxedoColor();
        update_Coin_Pocket(coin_pocket_value);
      }
    }
    else if (dataPageValue == "custom-made-tuxedo-waistcoat") {
      // Iterate through each parent div for jacket model
      for (let i = 0; i < parentDivs.length; i++) {
        // Get the child div with the class "cm-modifier-card-wrapper"
        childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
        // Check if the child div exists
        if (childDiv) {
          // Access data or perform actions on the child div
          filter_label = childDiv.querySelector(".cm-modifier-col-title");
          // Find the children div with class "cm-modifier-result-title" within childDiv
          resultTitleDiv = childDiv.querySelector(".cm-modifier-result-title");

          if (resultTitleDiv) {
            resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
            filter_label_value = filter_label.textContent.trim();
            resultTitleTextWithoutSpaces = resultTitleText.replace(
              /[.\s:]+/g,
              "_"
            ); // Replace spaces and dots with underscores

            filter_label_value = filter_label_value.replace(
              /[.\s:]+/g,
              "_"
            );

            console.log("debug-waistcoat ::", filter_label_value, resultTitleTextWithoutSpaces )

          }
          if (filter_label_value == "Buttoning") {
            if (resultTitleTextWithoutSpaces == "Single_Breasted_4_buttons") {
              resultTitleTextWithoutSpaces = "Single_Breasted_4_V_Shape";
            } else if (
              resultTitleTextWithoutSpaces == "Single_Breasted_5_buttons"
            ) {
              resultTitleTextWithoutSpaces = "Single_Breasted_5_V_Shape";
            } else if (
              resultTitleTextWithoutSpaces == "Single_Breasted_6_buttons"
            ) {
              resultTitleTextWithoutSpaces = "Single_Breasted_6_V_Shape";
            } else if (
              resultTitleTextWithoutSpaces == "Double_Breasted_6_buttons"
            ) {
              resultTitleTextWithoutSpaces = "Double_Breasted_6_button_V";
            }
            twbuttoning = resultTitleTextWithoutSpaces;
          }
          if (filter_label_value == "Collar_style") {
            if (resultTitleTextWithoutSpaces == "V_shape") {
              resultTitleTextWithoutSpaces = "None";
            } else if (resultTitleTextWithoutSpaces == "Shawl_lapel") {
              resultTitleTextWithoutSpaces = "shawlLapel";
            } else if (resultTitleTextWithoutSpaces == "Notch_Lapel") {
              resultTitleTextWithoutSpaces = "Notch";
            } else if (resultTitleTextWithoutSpaces == "Peak_Lapel") {
              resultTitleTextWithoutSpaces = "Peak";
            } else if ((resultTitleTextWithoutSpaces = "Horse_shoe")) {
              resultTitleTextWithoutSpaces = "Horse";
            }
            twcollarStyle = resultTitleTextWithoutSpaces;
          }
          if (filter_label_value == "Chest_pocket") {
            if (resultTitleTextWithoutSpaces == "Single_Pocket") {
              resultTitleTextWithoutSpaces = "Single_pocket";
            } else if (resultTitleTextWithoutSpaces == "Dual_Pockets") {
              resultTitleTextWithoutSpaces = "Double_pocket";
            }
            twpocketsBack = resultTitleTextWithoutSpaces;
          }
          if (filter_label_value == "Side_pocket") {
            if (resultTitleTextWithoutSpaces == "Straight_Pocket") {
              resultTitleTextWithoutSpaces = "Straight_pocket";
            } else if (resultTitleTextWithoutSpaces == "Jetted_Pocket") {
              resultTitleTextWithoutSpaces = "Jetted_pocket";
            }
            twpocketSide = resultTitleTextWithoutSpaces;
          }
          if (filter_label_value == "AMF_Stitching") {
            if (resultTitleTextWithoutSpaces == "2mm_(Standard)") {
              resultTitleTextWithoutSpaces = "AMF_2";
            } else if (resultTitleTextWithoutSpaces == "6mm") {
              resultTitleTextWithoutSpaces = "AMF_6";
            }
            amfSize = resultTitleTextWithoutSpaces;
          }
          if (filter_label_value == "Back_style") {
            twbackStyle = resultTitleTextWithoutSpaces;
          }
          if (filter_label_value == "Buttons") {
            sButtons_texture = resultTitleTextWithoutSpaces;
            updateButtonImage(WCollar_Styles.children[0].children[3].material);
          }
          if (filter_label_value == "Lining_choice") {
            // if (resultTitleTextWithoutSpaces == "White") {
            //   resultTitleTextWithoutSpaces = "#ffffff";
            // } else if (resultTitleTextWithoutSpaces == "Light_Grey") {
            //   resultTitleTextWithoutSpaces = "#4d4d54";
            // } else if (resultTitleTextWithoutSpaces == "Dark_Grey") {
            //   resultTitleTextWithoutSpaces = "#282024";
            // } else if (resultTitleTextWithoutSpaces == "Light_Blue") {
            //   resultTitleTextWithoutSpaces = "#40546b";
            // } else if (resultTitleTextWithoutSpaces == "Pink") {
            //   resultTitleTextWithoutSpaces = "#c72b52";
            // }
            // backColor = resultTitleTextWithoutSpaces;
            backColor = getLiningColor(resultTitleTextWithoutSpaces);
          }
        }
        updateSidePockets();
        updateChestPockets();
        updateCollarStyles();
        updateBackColor(backColor);
      }
    } 
    else if (dataPageValue == "custom-made-tuxedo-suit") {
      if (jacketdiv.classList.contains("isSelected")) {
        for (let i = 0; i < 19; i++) {
          childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
          if (childDiv) {
            filter_label = childDiv.querySelector(".cm-modifier-col-title");
            resultTitleDiv = childDiv.querySelector(
              ".cm-modifier-result-title"
            );
            if (resultTitleDiv) {
              resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
              filter_label_value = filter_label.textContent.trim();
              resultTitleTextWithoutSpaces = resultTitleText.replace(
                /[.\s:]+/g,
                "_"
              ); // Replace spaces and dots with underscores
              filter_label_value = filter_label_value.replace(
              /[.\s:]+/g,
              "_"
            );

            }
            if (filter_label_value == "Buttoning") {
              if (resultTitleTextWithoutSpaces == "Single_Breasted_1_button") {
                resultTitleTextWithoutSpaces = "taxido-button-1";
              } else if (
                resultTitleTextWithoutSpaces == "Single_Breasted_2_button"
              ) {
                resultTitleTextWithoutSpaces = "taxido-button-2";
              } else if (
                resultTitleTextWithoutSpaces == "Double_Breasted_4_button"
              ) {
                resultTitleTextWithoutSpaces = "taxido-button-4";
              } else if (
                resultTitleTextWithoutSpaces == "Double_Breasted_6_button"
              ) {
                resultTitleTextWithoutSpaces = "taxido-button-6";
              } else if (
                resultTitleTextWithoutSpaces == "Double_Breasted_6_button_low"
              ) {
                resultTitleTextWithoutSpaces = "taxido-button-7";
              }
              intialmodel = resultTitleTextWithoutSpaces;
              let activediv = childDiv.querySelector(
                ".cm-modifier-card-content"
              );
              if (activediv.classList.contains("active-option")) {
                // // console.log(newresultTitleDiv);
                loadLoader();
                // console.log(resultTitleTextWithoutSpaces)
                loadGLTFmoadl(intialmodel);
                // scene.children.forEach(child => {
                //     // Check if the child corresponds to any model from the loadedModels array
                //     if (Object.values(loadedModels).includes(child)) {
                //         // Remove the child from the scene
                //         scene.remove(child);
                //     }
                // });

                // // Add the new model to the scene if it exists in the loadedModels array
                // if (loadedModels[resultTitleTextWithoutSpaces]) {
                //     scene.add(loadedModels[resultTitleTextWithoutSpaces]);
                // }
              }
            }
            if (filter_label_value == "Lapel_style") {
              if (resultTitleTextWithoutSpaces == "Peak") {
                resultTitleTextWithoutSpaces = "peak";
              } else if (resultTitleTextWithoutSpaces == "Shawl") {
                resultTitleTextWithoutSpaces = "Shawl";
              }
              Lapel_style_value = resultTitleTextWithoutSpaces;
            }
            if (filter_label_value == "Lapel_width") {
              if (resultTitleTextWithoutSpaces == "Narrow") {
                resultTitleTextWithoutSpaces = "narrow";
              } else if (resultTitleTextWithoutSpaces == "Standard") {
                resultTitleTextWithoutSpaces = "standard";
              } else if (resultTitleTextWithoutSpaces == "Wide") {
                resultTitleTextWithoutSpaces = "wide";
              }
              Lapel_width = resultTitleTextWithoutSpaces;
            }
            if (filter_label_value == "Lapel_material") {
              if (resultTitleTextWithoutSpaces == "Black_satin") {
              sColorType = "satin"
              resultTitleTextWithoutSpaces = "black";
            } else if (resultTitleTextWithoutSpaces == "Navy_satin") {
              sColorType = "satin"
              resultTitleTextWithoutSpaces = "blue";
            } else if (resultTitleTextWithoutSpaces == "White_satin") {
              sColorType = "satin"
              resultTitleTextWithoutSpaces = "white";
            } else if (resultTitleTextWithoutSpaces == "Black_grosgrain") {
              sColorType = "grosgrain"
              resultTitleTextWithoutSpaces = "black";
            } else if (resultTitleTextWithoutSpaces == "Navy_grosgrain") {
              sColorType = "grosgrain"
              resultTitleTextWithoutSpaces = "blue";
            } else if (resultTitleTextWithoutSpaces == "White_grosgrain") {
              sColorType = "grosgrain"
              resultTitleTextWithoutSpaces = "white";
            } else {
              resultTitleTextWithoutSpaces = "None";
            }
            sTuxedoColor = resultTitleTextWithoutSpaces;
            updateTuxedoColor();
            }
            if (filter_label_value == "Shoulder") {
              if (
                resultTitleTextWithoutSpaces ==
                "Rope_Shoulder_-_Structured_(5_mm)"
              ) {
                resultTitleTextWithoutSpaces = "Rounded_Shoulder_5mm";
              } else if (
                resultTitleTextWithoutSpaces ==
                "Rope_Shoulder_-_Lightly_Padded_(2_mm)"
              ) {
                resultTitleTextWithoutSpaces = "Rounded_Shoulder_2mm";
              } else if (
                resultTitleTextWithoutSpaces ==
                "Natural_Shoulder_-_Structured_(5_mm)"
              ) {
                resultTitleTextWithoutSpaces = "Natural_Shoulder_5mm";
              } else if (
                resultTitleTextWithoutSpaces ==
                "Natural_Shoulder_-_Lightly_Padded_(2_mm)"
              ) {
                resultTitleTextWithoutSpaces = "Natural_Shoulder_2mm";
              } else if (
                resultTitleTextWithoutSpaces ==
                "Natural_Shoulder_-_Unconstructed_(0_mm)"
              ) {
                resultTitleTextWithoutSpaces = "Natural_Shoulder_0mm";
              } else if (
                resultTitleTextWithoutSpaces ==
                "La_Spalla_Camicia_-_Lightly_Padded_(2_mm)"
              ) {
                resultTitleTextWithoutSpaces = "spalla_camicia_2mm";
              } else if (
                resultTitleTextWithoutSpaces ==
                "La_Spalla_Camicia_-_Unconstrcuted_(0_mm)"
              ) {
                resultTitleTextWithoutSpaces = "spalla_camicia_0mm";
              }
              Shoulder = resultTitleTextWithoutSpaces;
            }

            if (filter_label_value == "Chest_pocket") {
              if (resultTitleTextWithoutSpaces == "Boat") {
                resultTitleTextWithoutSpaces = "Boat_Shape";
              } else if (resultTitleTextWithoutSpaces == "Patch") {
                resultTitleTextWithoutSpaces = "patch";
              } else if (resultTitleTextWithoutSpaces == "Rounded_patch") {
                resultTitleTextWithoutSpaces = "Rounded";
              } else if (resultTitleTextWithoutSpaces == "Pleat_patch") {
                resultTitleTextWithoutSpaces = "pleat_B";
              }
              Chest_Pocket_value = resultTitleTextWithoutSpaces;
            }

            if (filter_label_value == "Side_pockets") {
              if (resultTitleTextWithoutSpaces == "Slanted_flap") {
                resultTitleTextWithoutSpaces = "Slanted_Flap001";
              } else if (resultTitleTextWithoutSpaces == "Jetted") {
                resultTitleTextWithoutSpaces = "Jetted001";
              } else if (resultTitleTextWithoutSpaces == "Slanted_jetted") {
                resultTitleTextWithoutSpaces = "Slanted_Jetted001";
              }
              side_pocket_value = resultTitleTextWithoutSpaces;
            }

            if (filter_label_value == "Ticket_pocket") {
              if (resultTitleTextWithoutSpaces == "Yes") {
                Ticket_pocket_value = true;
              } else {
                Ticket_pocket_value = false;
              }
            }

            if (filter_label_value == "Buttons") {
              sButtons_texture = resultTitleTextWithoutSpaces;
              updateButtonImage(buttons.children[3].children[1].material);
            }

            if (filter_label_value == "Lining") {
              if (resultTitleTextWithoutSpaces == "Half_Lined") {
                resultTitleTextWithoutSpaces = "halfline";
              } else if (resultTitleTextWithoutSpaces == "Fully_Lined") {
                resultTitleTextWithoutSpaces = "full";
              }
              Lining_value = resultTitleTextWithoutSpaces;
            }

            if (filter_label_value == "Vent") {
              if (resultTitleTextWithoutSpaces == "Double") {
                resultTitleTextWithoutSpaces = "double";
              } else if (resultTitleTextWithoutSpaces == "Single") {
                resultTitleTextWithoutSpaces = "single";
              } else if (resultTitleTextWithoutSpaces == "None") {
                resultTitleTextWithoutSpaces = "none";
              }
              Vent_value = resultTitleTextWithoutSpaces;
            }

            if (filter_label_value == "Sleeve_buttons") {
              if (resultTitleTextWithoutSpaces == "3_kissing") {
                resultTitleTextWithoutSpaces = "kissing_3";
              } else if (resultTitleTextWithoutSpaces == "3_non-kissing") {
                resultTitleTextWithoutSpaces = "non_kissing_3";
              } else if (
                resultTitleTextWithoutSpaces == "4_kissing_(Standard)"
              ) {
                resultTitleTextWithoutSpaces = "kissing_4";
              } else if (resultTitleTextWithoutSpaces == "4_non-kissing") {
                resultTitleTextWithoutSpaces = "non_kissing_4";
              } else if (
                resultTitleTextWithoutSpaces == "5_kissing_special_(Tom_Ford)"
              ) {
                resultTitleTextWithoutSpaces = "kissing_5";
              } else if (resultTitleTextWithoutSpaces == "5_non-kissing") {
                resultTitleTextWithoutSpaces = "non_kissing_5";
              } else if (resultTitleTextWithoutSpaces == "1_sleeve_button") {
                resultTitleTextWithoutSpaces = "sleeve_button_1";
              }
              Sleeve_Button_value = resultTitleTextWithoutSpaces;
            }
            
            if (filter_label_value == "AMF") {
              if (resultTitleTextWithoutSpaces == "2_mm_(Standard)") {
                resultTitleTextWithoutSpaces = "mm2";
              } else if (resultTitleTextWithoutSpaces == "6_mm") {
                resultTitleTextWithoutSpaces = "mm6";
              }
              AMF_Size = resultTitleTextWithoutSpaces;
            }

            if (filter_label_value == "Cuffed_sleeve") {
              if (resultTitleTextWithoutSpaces == "Yes") {
                Cuffed_sleeve_value = true;
              } else {
                Cuffed_sleeve_value = false;
              }
            }

            if (filter_label_value == "Buttonhole_lapel_position") {
              if (resultTitleTextWithoutSpaces == "Left_(Standard)") {
                resultTitleTextWithoutSpaces = "right";
              } else if (resultTitleTextWithoutSpaces == "Right") {
                resultTitleTextWithoutSpaces = "left";
              }
              hole_Position = resultTitleTextWithoutSpaces;
            }
            if (filter_label_value == "Buttonhole_lapel") {
              if (resultTitleTextWithoutSpaces == "Traditional") {
                resultTitleTextWithoutSpaces = "Handmade";
              } else if (resultTitleTextWithoutSpaces == "milanese") {
                resultTitleTextWithoutSpaces = "Traditional";
              }
              Lapel_buttonhole = resultTitleTextWithoutSpaces;
            }
            
            if (filter_label_value  == "Lining_colour") {
              sLiningColor = getLiningColor(resultTitleTextWithoutSpaces);
              update_lining_color();
            }

            update_Lapel_width();
            update_Shoulders();
            update_Side_Pocket();
            update_Ticket_pockets();
            update_Vent();
            update_Lining();
            update_Sleeve_Button();
            update_Chest_Pocket();
            // updateTuxedoColor();
            update_Cuffed_sleeve(Cuffed_sleeve_value);
          }
        }
      }
      else if (trouserdiv.classList.contains("isSelected")) {
        for (let i = 20; i < 34; i++) {
          // Get the child div with the class "cm-modifier-card-wrapper"
          childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
          // Check if the child div exists
          if (childDiv) {
            // Access data or perform actions on the child div

            // Find the children div with class "cm-modifier-result-title" within childDiv
            resultTitleDiv = childDiv.querySelector(
              ".cm-modifier-result-title"
            );

            if (resultTitleDiv) {
              resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
              resultTitleTextWithoutSpaces = resultTitleText.replace(
                /[.\s:]+/g,
                "_"
              ); // Replace spaces and dots with underscores
              // console.log("Result Title: " + resultTitleTextWithoutSpaces); // Log the modified text content
            }
            if (i == 20) {
              if (
                resultTitleTextWithoutSpaces == "Oscar_Straight_[7_cm_overlap]"
              ) {
                resultTitleTextWithoutSpaces = "Oscar_Straight";
              } else if (
                resultTitleTextWithoutSpaces ==
                "Oscar_Straight_Extended_[11_cm_overlap]"
              ) {
                resultTitleTextWithoutSpaces = "Oscar_Straight_Extended";
              } else if (
                resultTitleTextWithoutSpaces ==
                "Oscar_Straight_Extended_[11_cm_overlap]"
              ) {
                resultTitleTextWithoutSpaces = "Oscar_Straight_Extended";
              } else if (
                resultTitleTextWithoutSpaces == "Oscar_Peak_[7_cm_overlap]"
              ) {
                resultTitleTextWithoutSpaces = "Oscar_Peak";
              } else if (
                resultTitleTextWithoutSpaces ==
                "Oscar_Peak_Extended_[11_cm_overlap]"
              ) {
                resultTitleTextWithoutSpaces = "Oscar_Peak_Extended";
              } else if (resultTitleTextWithoutSpaces == "Drawstring") {
                resultTitleTextWithoutSpaces = "DrawString";
              } else if (resultTitleTextWithoutSpaces == "Original_Gurkha") {
                resultTitleTextWithoutSpaces = "Gurkha_double";
              }
              waistband_value = resultTitleTextWithoutSpaces;
            }
            if (i == 21) {
              if (resultTitleTextWithoutSpaces == "3_5_cm") {
                resultTitleTextWithoutSpaces = "0";
              } else if (resultTitleTextWithoutSpaces == "4_cm") {
                resultTitleTextWithoutSpaces = "1";
              } else if (resultTitleTextWithoutSpaces == "5_cm") {
                resultTitleTextWithoutSpaces = "2";
              }
              if(childDiv.closest(".cm-modifier-card-container").style.display != 'none'){
                waistband_height = resultTitleTextWithoutSpaces;
              }else{
                waistband_height = 0;
              }
            }
            if (i == 22) {
              if (resultTitleTextWithoutSpaces == "None") {
                resultTitleTextWithoutSpaces = "None";
              } else if (resultTitleTextWithoutSpaces == "Belt_Loop") {
                resultTitleTextWithoutSpaces = "Belt";
              } else if (resultTitleTextWithoutSpaces == "Side-adjusters") {
                resultTitleTextWithoutSpaces = "Side_adjusters_";
              } else if (resultTitleTextWithoutSpaces == "Lowered_Side-adjusters") {
                resultTitleTextWithoutSpaces = "Lower_Side_adjusters";
              }
              if(childDiv.closest(".cm-modifier-card-container").style.display != 'none'){
                fasteting_value = resultTitleTextWithoutSpaces;
              }else{
                fasteting_value = "None";
              }
            }
            if (i == 23) {
              if (resultTitleTextWithoutSpaces == "Yes") {
                coin_pocket_value = true;
              } else if (resultTitleTextWithoutSpaces == "No") {
                coin_pocket_value = false;
              }
            }
            if (i == 24) {
            }
            if (i == 25) {
              if (resultTitleTextWithoutSpaces == "No_pleats") {
                resultTitleTextWithoutSpaces = "Normal_straight_pant";
              } else if (
                resultTitleTextWithoutSpaces == "Outward_Single_Pleats"
              ) {
                resultTitleTextWithoutSpaces = "Standardsinglee";
              } else if (
                resultTitleTextWithoutSpaces == "Outward_Double_Pleats"
              ) {
                resultTitleTextWithoutSpaces = "StandardDouble";
              } else if (
                resultTitleTextWithoutSpaces == "Inward_Single_Pleats"
              ) {
                resultTitleTextWithoutSpaces = "INWARDSINGLE";
              } else if (
                resultTitleTextWithoutSpaces == "Inward_Double_Pleats"
              ) {
                resultTitleTextWithoutSpaces = "INWARDDouble";
              }
              Pleat = resultTitleTextWithoutSpaces;
            }
            if (i == 26) {
              if (resultTitleTextWithoutSpaces == "Plain") {
                resultTitleTextWithoutSpaces = "None";
              } else if (
                resultTitleTextWithoutSpaces == "Turn_up_6_cm/_XX_inches_"
              ) {
                resultTitleTextWithoutSpaces = "HemFinishing6CM";
              } else if (
                resultTitleTextWithoutSpaces ==
                "Turn_up_5_cm_/_XX_inches_(Standard)"
              ) {
                resultTitleTextWithoutSpaces = "HemFinishing5CM";
              } else if (
                resultTitleTextWithoutSpaces == "Turn_up_4_cm/_XX_inches_"
              ) {
                resultTitleTextWithoutSpaces = "HemFinishing4CM";
              }
              Hem_finishing_value = resultTitleTextWithoutSpaces;
            }
            if (i == 27) {
              if (resultTitleTextWithoutSpaces == "2_mm_(Standard)") {
                resultTitleTextWithoutSpaces = "AMF_2";
              } else if (resultTitleTextWithoutSpaces == "6_mm") {
                resultTitleTextWithoutSpaces = "AMF_6";
              }
              TAMF_Size = resultTitleTextWithoutSpaces;
            }
            if (i == 28) {
              pocket_side = resultTitleTextWithoutSpaces;
            }
            if (i == 29) {
              if (resultTitleTextWithoutSpaces == "Black_satin") {
                resultTitleTextWithoutSpaces = "#000000";
              } else if (resultTitleTextWithoutSpaces == "Navy_satin") {
                resultTitleTextWithoutSpaces = "#34394a";
              } else if (resultTitleTextWithoutSpaces == "White_satin") {
                resultTitleTextWithoutSpaces = "#a8a8a8";
              } else {
                resultTitleTextWithoutSpaces = "None";
              }
              colorTuxedo = resultTitleTextWithoutSpaces;
            }
            if (i == 30) {
              if (resultTitleTextWithoutSpaces == "Jetted") {
                resultTitleTextWithoutSpaces = "jetted_Button";
              } else if (resultTitleTextWithoutSpaces == "Jetted_No_Button") {
                resultTitleTextWithoutSpaces = "jetted_no_Button";
              } else if (resultTitleTextWithoutSpaces == "Jetted_No_Button") {
                resultTitleTextWithoutSpaces = "jetted_no_Button";
              }
              pockets_back = resultTitleTextWithoutSpaces;
            }
            if (i == 31) {
              sButtons_texture = resultTitleTextWithoutSpaces;
              updateButtonImage(coin_Pocket.children[0].children[0].material);
            }
          }
          update_Hem_finishing();
          update_Pleats();
          update_side_Pockets();
          update_Back_Pockets();
          update_Waistband();
          TupdateTuxedoColor();
          update_Coin_Pocket();
        }
      }
      else if (waistecoatdiv.classList.contains("isSelected")) {
        for (let i = 35; i <= 43; i++) {
          // Get the child div with the class "cm-modifier-card-wrapper"
          childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");
          // Check if the child div exists
          if (childDiv) {
            // Access data or perform actions on the child div
            // console.log("i" + i + childDiv.textContent); // For example, logging the text content of each card wrapper

            // Find the children div with class "cm-modifier-result-title" within childDiv
            resultTitleDiv = childDiv.querySelector(
              ".cm-modifier-result-title"
            );

            if (resultTitleDiv) {
              resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
              resultTitleTextWithoutSpaces = resultTitleText.replace(
                /[.\s:]+/g,
                "_"
              ); // Replace spaces and dots with underscores
            }
            if (i == 36) {
              if (resultTitleTextWithoutSpaces == "Single_Breasted_4_buttons") {
                resultTitleTextWithoutSpaces = "Single_Breasted_4_V_Shape";
              } else if (
                resultTitleTextWithoutSpaces == "Single_Breasted_5_buttons"
              ) {
                resultTitleTextWithoutSpaces = "Single_Breasted_5_V_Shape";
              } else if (
                resultTitleTextWithoutSpaces == "Single_Breasted_6_buttons"
              ) {
                resultTitleTextWithoutSpaces = "Single_Breasted_6_V_Shape";
              } else if (
                resultTitleTextWithoutSpaces == "Double_Breasted_6_buttons"
              ) {
                resultTitleTextWithoutSpaces = "Double_Breasted_6_button_V";
              }
              twbuttoning = resultTitleTextWithoutSpaces;
            }
            if (i == 37) {
              if (resultTitleTextWithoutSpaces == "V_shape") {
                resultTitleTextWithoutSpaces = "None";
              } else if (resultTitleTextWithoutSpaces == "Shawl_lapel") {
                resultTitleTextWithoutSpaces = "shawlLapel";
              } else if (resultTitleTextWithoutSpaces == "Notch_Lapel") {
                resultTitleTextWithoutSpaces = "Notch";
              } else if (resultTitleTextWithoutSpaces == "Peak_Lapel") {
                resultTitleTextWithoutSpaces = "Peak";
              } else if ((resultTitleTextWithoutSpaces = "Horse_shoe")) {
                resultTitleTextWithoutSpaces = "Horse";
              }
              twcollarStyle = resultTitleTextWithoutSpaces;
            }
            if (i == 38) {
              if (resultTitleTextWithoutSpaces == "Single_Pocket") {
                resultTitleTextWithoutSpaces = "Single_pocket";
              } else if (resultTitleTextWithoutSpaces == "Dual_Pockets") {
                resultTitleTextWithoutSpaces = "Double_pocket";
              }
              twpocketsBack = resultTitleTextWithoutSpaces;
            }
            if (i == 39) {
              if (resultTitleTextWithoutSpaces == "Straight_Pocket") {
                resultTitleTextWithoutSpaces = "Straight_pocket";
              } else if (resultTitleTextWithoutSpaces == "Jetted_Pocket") {
                resultTitleTextWithoutSpaces = "Jetted_pocket";
              }
              twpocketSide = resultTitleTextWithoutSpaces;
            }
            if (i == 40) {
              if (resultTitleTextWithoutSpaces == "2mm_(Standard)") {
                resultTitleTextWithoutSpaces = "AMF_2";
              } else if (resultTitleTextWithoutSpaces == "6mm") {
                resultTitleTextWithoutSpaces = "AMF_6";
              }
              amfSize = resultTitleTextWithoutSpaces;
            }
            if (i == 41) {
              twbackStyle = resultTitleTextWithoutSpaces;
            }
            if (i == 42) {
              sButtons_texture = resultTitleTextWithoutSpaces;
              updateButtonImage(
                WCollar_Styles.children[0].children[3].material
              );
            }
            if (i == 43) {
              // if (resultTitleTextWithoutSpaces == "White") {
              //   resultTitleTextWithoutSpaces = "#ffffff";
              // } else if (resultTitleTextWithoutSpaces == "Light_Grey") {
              //   resultTitleTextWithoutSpaces = "#4d4d54";
              // } else if (resultTitleTextWithoutSpaces == "Dark_Grey") {
              //   resultTitleTextWithoutSpaces = "#282024";
              // } else if (resultTitleTextWithoutSpaces == "Light_Blue") {
              //   resultTitleTextWithoutSpaces = "#40546b";
              // } else if (resultTitleTextWithoutSpaces == "Pink") {
              //   resultTitleTextWithoutSpaces = "#c72b52";
              // }
              // backColor = resultTitleTextWithoutSpaces;
              backColor = getLiningColor(resultTitleTextWithoutSpaces);
            }
          }
          updateSidePockets();
          updateChestPockets();
          updateCollarStyles();
          updateBackColor(backColor);
        }
      }
    }
    $("body").removeClass("line-loading-3d-preview");
    obj.classList.contains("inactive_button") ? obj.classList.remove("inactive_button") : '';
  }, 300);
}

const fabricLists = document.querySelectorAll(".cm-card-list fabric-list");

if (fabricLists.length > 0) {
  const firstFabricList = fabricLists[0];
  const contentWrapper = firstFabricList.querySelector(
    ".cm-card-content-wrapper"
  );

  if (contentWrapper) {
    const fabricId = contentWrapper.getAttribute("data-fabricid");
    defaultfabriccode = fabricId;
  } else {
    console.log("No content wrapper found within the first fabric-list tag.");
  }
} else {
  console.log("No fabric-list tags found.");
}

fabricLists.forEach((fabricList) => {
  fabricList.addEventListener("click", function () {
    const contentWrapper = this.querySelector(".cm-card-content-wrapper");
    if (contentWrapper) {
      const fabricId = contentWrapper.getAttribute("data-fabricid");
      // console.log('Clicked on fabric-list tag with data-fabricid:', fabricId);
      const fid = allfabrics?.filter((fabric) => fabric.id === fabricId);
      // console.log("fid",fid)
      sCurruntFabric = fid[0];
      if (
        dataPageValue == "custom-made-tuxedo-trouser" ||
        trouserdiv.classList.contains("isSelected") ||
        trouseractive
      ) {
        TupdateMaterialFabric(fid[0]);
      } else if (
        dataPageValue == "custom-made-tuxedo-waistcoat" ||
        waistecoatdiv.classList.contains("isSelected") ||
        waistcoatactive
      ) {
        WupdateMaterialFabric(fid[0]);
      } else {
        // console.log(fabricId)
        updateMaterialFabric(fid[0]);
      }
    } else {
      // console.log('No content wrapper found within the clicked fabric-list tag.');
    }
  });
});

function getLiningColor(color_code) {
  switch (color_code) {
    case "White":
      return "#C6C3BC";
      break;
    case "Black":
      return "#111111";
      break;
    case "Dark_Navy":
      return "#112139";
      break;
    case "Navy":
      return "#1D1F34";
      break;
    case "Mid_Navy":
      return "#1A2F4C";
      break;
    case "Dark_Grey":
      return "#4D4D4D";
      break;
    case "Light_Grey":
      return "#898989";
      break;
    case "Brown":
      return "#2e241e";
      break;
    case "Light_Blue":
      return "#9AB5C0";
      break;
    case "Light_Brown":
      return "#685037";
      break;
    case "Dark_Brown":
      return "#52402E";
      break;
    case "Beige":
      return "#AB947A";
      break;
    case "Khaki_green":
      return "#453b22";
      break;
    case "Pink":
      return "#9c5a70";
      break;
    case "Burgundy":
      return "#5E1A27";
      break;
    case "Red":
      return "#5A0206";
      break;
    case "Orange":
      return "#A8513C";
      break;
    case "Purple":
      return "#7e4eb5";
      break;
    case "Black_satin":
      return "#111111";
      break;
    case "Black_grosgrain":
      return "#141414";
      break;
    case "Navy_satin":
      return "#212239";
      break;
    case "Navy_grosgrain":
      return "#191F30";
      break;
    case "White_satin":
      return "#C2C0B8";
      break;
    case "White_grosgrain":
      return "#C3BDAE";
      break;
    default:
      return "#FFFFFF";
      break;
  }
}
